type IconsPros = {
  type?: string
  className?: string
}

export default function Icon({ type, className }: IconsPros) {
  return (
    <>
      {type === 'check' && (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="yes 1" clipPath="url(#clip0_108_2114)">
            <path
              id="Vector"
              d="M6.50001 13.2835C9.9702 13.2835 12.7833 10.4703 12.7833 7.00013C12.7833 3.52994 9.9702 0.716797 6.50001 0.716797C3.02982 0.716797 0.216675 3.52994 0.216675 7.00013C0.216675 10.4703 3.02982 13.2835 6.50001 13.2835Z"
              fill="#404041"
            />
            <path
              id="Vector_2"
              d="M5.25678 9.61512L3.78345 8.17602C3.75158 8.14505 3.72625 8.10799 3.70895 8.06706C3.69165 8.02612 3.68274 7.98213 3.68274 7.93769C3.68274 7.89324 3.69165 7.84925 3.70895 7.80832C3.72625 7.76738 3.75158 7.73033 3.78345 7.69935L4.27203 7.22269C4.33755 7.1592 4.4252 7.1237 4.51643 7.1237C4.60766 7.1237 4.69531 7.1592 4.76083 7.22269L5.6379 8.08004L8.09772 4.34037C8.14847 4.26491 8.22658 4.21214 8.31553 4.19322C8.40448 4.17429 8.49731 4.1907 8.57438 4.23897L9.15592 4.60427C9.1939 4.62763 9.22681 4.65837 9.25268 4.69468C9.27856 4.73099 9.29688 4.77213 9.30656 4.81566C9.31624 4.85919 9.31708 4.90421 9.30903 4.94807C9.30098 4.99192 9.2842 5.03372 9.2597 5.07097L6.34705 9.5005C6.28869 9.58721 6.21202 9.66006 6.12246 9.71393C6.0329 9.7678 5.93261 9.80138 5.82867 9.81231C5.72473 9.82324 5.61965 9.81125 5.52085 9.77718C5.42204 9.74311 5.3319 9.68779 5.25678 9.61512Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_108_2114">
              <rect
                width="13"
                height="13"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'global' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g clipPath="url(#clip0_5_16315)">
            <path
              d="M8 0.5C6.51664 0.5 5.0666 0.939867 3.83323 1.76398C2.59986 2.58809 1.63856 3.75943 1.07091 5.12987C0.50325 6.50032 0.354725 8.00832 0.644114 9.46318C0.933503 10.918 1.64781 12.2544 2.6967 13.3033C3.7456 14.3522 5.08197 15.0665 6.53683 15.3559C7.99168 15.6453 9.49968 15.4968 10.8701 14.9291C12.2406 14.3614 13.4119 13.4001 14.236 12.1668C15.0601 10.9334 15.5 9.48336 15.5 8C15.4976 6.01163 14.7066 4.1054 13.3006 2.6994C11.8946 1.29341 9.98837 0.502448 8 0.5ZM1.26 6.11L1.54 6.52C1.5527 6.5381 1.55796 6.56038 1.55471 6.58224C1.55145 6.60411 1.53992 6.62389 1.5225 6.6375L1.2375 6.855C1.17175 6.90471 1.12641 6.97672 1.11 7.0575L1.02 7.4875C1.05215 7.02127 1.13258 6.55963 1.26 6.11ZM13.525 5.2475C13.5924 5.25067 13.6574 5.27407 13.7113 5.31465C13.7653 5.35522 13.8057 5.4111 13.8275 5.475L13.84 5.51C13.865 5.58638 13.9136 5.6529 13.9787 5.70004C14.0438 5.74718 14.1221 5.77255 14.2025 5.7725H14.635C14.6945 5.94232 14.7454 6.11504 14.7875 6.29L14.375 6.7025C14.3678 6.70968 14.3592 6.71537 14.3497 6.71923C14.3403 6.72309 14.3302 6.72505 14.32 6.725H13.705C13.6949 6.72501 13.685 6.72299 13.6757 6.71906C13.6664 6.71514 13.6581 6.70939 13.6511 6.70216C13.6441 6.69493 13.6386 6.68636 13.635 6.67697C13.6314 6.66758 13.6297 6.65756 13.63 6.6475C13.6301 6.58557 13.6125 6.52491 13.5793 6.47265C13.5461 6.42038 13.4986 6.3787 13.4425 6.3525C13.3867 6.32522 13.3241 6.31471 13.2625 6.32226C13.2008 6.3298 13.1426 6.35507 13.095 6.395L11.95 7.325C11.7494 7.48697 11.5878 7.69192 11.477 7.92471C11.3663 8.1575 11.3092 8.4122 11.31 8.67V9.5675C11.31 9.6102 11.3183 9.65249 11.3346 9.69195C11.3509 9.73142 11.3748 9.76728 11.405 9.7975L12.1975 10.5925C12.2598 10.6531 12.3431 10.6871 12.43 10.6875H12.73C12.8709 10.6878 13.0088 10.6471 13.1269 10.5703C13.245 10.4935 13.3382 10.3839 13.395 10.255L14.1725 11.3025C13.5741 12.4193 12.684 13.353 11.5971 14.0041C10.5102 14.6552 9.26703 14.9994 8 15C7.965 15 7.9325 15 7.8975 14.9975V14.9325C7.8975 14.8861 7.91594 14.8416 7.94876 14.8088C7.98158 14.7759 8.02609 14.7575 8.0725 14.7575C8.21088 14.7568 8.34339 14.7016 8.44124 14.6037C8.53909 14.5059 8.59435 14.3734 8.595 14.235V13.7725C8.59493 13.7284 8.61172 13.686 8.64194 13.6539C8.67216 13.6219 8.71351 13.6026 8.7575 13.6C8.84661 13.5939 8.93146 13.5596 8.99977 13.5021C9.06809 13.4445 9.11633 13.3668 9.1375 13.28C9.16123 13.1935 9.15627 13.1017 9.12336 13.0183C9.09045 12.9349 9.03137 12.8645 8.955 12.8175L7.6225 11.9675C7.59768 11.9518 7.5773 11.93 7.5633 11.9042C7.54929 11.8783 7.54213 11.8494 7.5425 11.82V11.5725C7.54184 11.4602 7.49677 11.3528 7.41714 11.2736C7.33751 11.1944 7.22979 11.15 7.1175 11.15H6.9025C6.77364 11.1493 6.65029 11.0977 6.5594 11.0063C6.46852 10.915 6.4175 10.7914 6.4175 10.6625C6.4175 10.6067 6.40651 10.5514 6.38515 10.4999C6.36379 10.4483 6.33249 10.4014 6.29302 10.362C6.25356 10.3225 6.20671 10.2912 6.15514 10.2699C6.10358 10.2485 6.04831 10.2375 5.9925 10.2375H4.0425C3.93022 10.2382 3.82276 10.2832 3.7436 10.3629C3.66443 10.4425 3.62 10.5502 3.62 10.6625V10.7925C3.62001 10.8347 3.60494 10.8755 3.5775 10.9075L3.135 11.425C3.07631 11.4936 3.04123 11.5792 3.03493 11.6692C3.02862 11.7593 3.05144 11.8489 3.1 11.925L3.39 12.3925C3.41131 12.4291 3.4393 12.4613 3.4725 12.4875L4.5325 13.4125C4.55106 13.4293 4.56597 13.4497 4.57629 13.4725C4.58662 13.4953 4.59213 13.52 4.5925 13.545V14.1125C3.50372 13.5058 2.59669 12.6193 1.96513 11.5447C1.33357 10.4701 1.00039 9.24643 1 8C1 7.9675 1 7.9325 1.0025 7.9C1.08816 8.35651 1.35049 8.76079 1.7325 9.025L3.3975 10.275C3.41944 10.2906 3.44557 10.2994 3.4725 10.3C3.49454 10.2996 3.51609 10.2935 3.53503 10.2822C3.55397 10.2709 3.56964 10.2549 3.58049 10.2357C3.59135 10.2165 3.59701 10.1948 3.59692 10.1728C3.59684 10.1507 3.59101 10.1291 3.58 10.11L2.82 8.8425C2.8075 8.8175 2.8075 8.8075 2.805 8.8075C2.81505 8.79644 2.82688 8.78714 2.84 8.78L3.0475 8.665C3.06732 8.65325 3.0836 8.63636 3.0946 8.61611C3.1056 8.59587 3.11092 8.57302 3.11 8.55C3.10914 8.52743 3.10217 8.50551 3.08984 8.48659C3.07752 8.46766 3.0603 8.45242 3.04 8.4425L2.5225 8.1925C2.50736 8.18493 2.49479 8.17307 2.48634 8.1584C2.47789 8.14373 2.47395 8.12689 2.475 8.11L2.4875 7.81C2.48754 7.79862 2.49001 7.78737 2.49475 7.77702C2.4995 7.76667 2.5064 7.75746 2.515 7.75C2.53228 7.73494 2.55459 7.72691 2.5775 7.7275L3.2125 7.755C3.22394 7.7547 3.23529 7.75703 3.24569 7.7618C3.25609 7.76656 3.26526 7.77364 3.2725 7.7825L3.825 8.3825C3.86882 8.43221 3.92671 8.46744 3.991 8.48351C4.05529 8.49958 4.12295 8.49574 4.185 8.4725C4.24835 8.45019 4.3036 8.40948 4.34368 8.35559C4.38376 8.30171 4.40685 8.23709 4.41 8.17L4.4225 7.835C4.42284 7.82367 4.42545 7.81252 4.43017 7.80221C4.4349 7.79191 4.44164 7.78265 4.45 7.775L5.26 7.03C5.27865 7.0153 5.30131 7.00659 5.325 7.005L5.9275 7.0325C6.01584 7.03564 6.10192 7.00425 6.1675 6.945C6.20022 6.91538 6.22677 6.8796 6.24565 6.8397C6.26452 6.79981 6.27535 6.75658 6.2775 6.7125L6.2925 6.3575C6.29258 6.34648 6.29509 6.33562 6.29984 6.32568C6.30459 6.31575 6.31148 6.30698 6.32 6.3L7.015 5.66C7.07773 5.60033 7.11529 5.51895 7.12 5.4325L7.155 4.845C7.1625 4.6775 7.0375 4.4175 6.8325 4.4075L6.1375 4.3825C6.09102 4.38146 6.0448 4.38977 6.00159 4.40692C5.95838 4.42408 5.91905 4.44974 5.88595 4.48239C5.85284 4.51503 5.82662 4.55399 5.80885 4.59695C5.79108 4.63991 5.78212 4.68601 5.7825 4.7325C5.78139 4.74216 5.77782 4.75137 5.77213 4.75924C5.76644 4.76712 5.75882 4.77341 5.75 4.7775C5.73309 4.78731 5.71414 4.79309 5.69463 4.79439C5.67512 4.79569 5.65557 4.79248 5.6375 4.785C5.4575 4.7 5.3875 4.395 5.3425 4.195L5.32 4.11C5.31706 4.09699 5.31711 4.08348 5.32014 4.07049C5.32317 4.0575 5.32911 4.04537 5.3375 4.035C5.34608 4.02415 5.35715 4.01553 5.36977 4.00988C5.3824 4.00422 5.3962 4.00169 5.41 4.0025L6.4675 4.0475C6.56697 4.05226 6.66639 4.03722 6.76 4.00325C6.85361 3.96928 6.93953 3.91705 7.01279 3.84961C7.08606 3.78216 7.14519 3.70083 7.18677 3.61035C7.22835 3.51986 7.25154 3.42202 7.255 3.3225L7.285 2.615C7.28839 2.52589 7.25637 2.43906 7.19595 2.37348C7.13552 2.3079 7.05159 2.2689 6.9625 2.265L6.635 2.2525C6.6137 2.25203 6.59336 2.24352 6.57806 2.22868C6.56276 2.21385 6.55363 2.19378 6.5525 2.1725C6.5525 1.5675 6.2425 1.4875 6.11 1.4825C5.90077 1.48252 5.69916 1.56103 5.545 1.7025C5.45669 1.79394 5.33696 1.84844 5.21 1.855C5.16255 1.85352 5.11647 1.83866 5.0771 1.81212C5.03773 1.78557 5.00667 1.74844 4.9875 1.705C4.985 1.7 4.9825 1.6925 4.98 1.6875C5.92177 1.23303 6.95431 0.997969 8 1C8.14 1 8.2775 1.005 8.415 1.015L8.5975 1.495C8.62545 1.56732 8.67447 1.62957 8.73821 1.6737C8.80195 1.71783 8.87748 1.7418 8.955 1.7425H9.9C9.93108 1.74158 9.96139 1.75228 9.985 1.7725L10.6425 2.31C10.6596 2.32419 10.6728 2.34241 10.6811 2.363C10.6894 2.3836 10.6925 2.40593 10.69 2.42799C10.6875 2.45005 10.6796 2.47115 10.6669 2.48939C10.6543 2.50763 10.6373 2.52245 10.6175 2.5325L10.5425 2.575C10.4956 2.59982 10.4544 2.63423 10.4217 2.67602C10.3889 2.7178 10.3654 2.76601 10.3525 2.8175C10.3393 2.86903 10.3369 2.92274 10.3456 2.97524C10.3542 3.02773 10.3736 3.07787 10.4025 3.1225L10.8725 3.8325C10.912 3.89235 10.9674 3.93997 11.0325 3.97L11.5175 4.19C11.5407 4.20096 11.5603 4.2183 11.574 4.23999C11.5878 4.26168 11.595 4.28683 11.595 4.3125V5.1825C11.5952 5.23931 11.6078 5.29538 11.632 5.34678C11.6562 5.39818 11.6913 5.44365 11.735 5.48C11.7497 5.49057 11.7619 5.50417 11.7709 5.51987C11.7798 5.53557 11.7853 5.55301 11.787 5.57102C11.7887 5.58902 11.7864 5.60717 11.7805 5.62425C11.7745 5.64132 11.765 5.65693 11.7525 5.67L11.2775 6.2125C11.1996 6.30218 11.1588 6.41824 11.1637 6.53696C11.1685 6.65567 11.2185 6.76805 11.3035 6.85109C11.3884 6.93414 11.5019 6.98158 11.6207 6.9837C11.7395 6.98582 11.8546 6.94246 11.9425 6.8625L12.995 5.905C13.0479 5.85667 13.0863 5.79467 13.1062 5.72585C13.126 5.65703 13.1265 5.58406 13.1075 5.515C13.102 5.49628 13.0986 5.47699 13.0975 5.4575C13.0978 5.42845 13.1039 5.39975 13.1155 5.37312C13.1271 5.34649 13.1439 5.32247 13.165 5.3025C13.2086 5.26227 13.2657 5.23995 13.325 5.24L13.525 5.2475Z"
              fill="currentColor"
            />
            <path
              d="M9.02761 2.2725H8.45761C8.4431 2.27266 8.42868 2.27012 8.41511 2.265L7.89761 2.105C7.87893 2.10003 7.85939 2.09925 7.84037 2.1027C7.82136 2.10616 7.80334 2.11377 7.78761 2.125C7.77144 2.1362 7.75823 2.15115 7.74909 2.16856C7.73995 2.18597 7.73515 2.20534 7.73511 2.225V2.56C7.73583 2.58941 7.73917 2.61869 7.74511 2.6475L8.09011 4.1825C8.10653 4.25648 8.14371 4.32423 8.19729 4.37782C8.25087 4.4314 8.31863 4.46858 8.39261 4.485C8.42068 4.48987 8.44911 4.49238 8.47761 4.4925C8.539 4.49253 8.59954 4.47805 8.65428 4.45024C8.70902 4.42244 8.75641 4.3821 8.79261 4.3325L9.34511 3.5925C9.3962 3.52378 9.4242 3.44063 9.42511 3.355V2.6675C9.42471 2.56243 9.38262 2.46181 9.30809 2.38775C9.23356 2.31369 9.13268 2.27224 9.02761 2.2725Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_5_16315">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'pencil' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M10 18.5C10 18.1022 10.158 17.7206 10.4393 17.4393C10.7206 17.158 11.1022 17 11.5 17C11.8978 17 12.2794 17.158 12.5607 17.4393C12.842 17.7206 13 18.1022 13 18.5C13 18.8978 12.842 19.2794 12.5607 19.5607C12.2794 19.842 11.8978 20 11.5 20C11.1022 20 10.7206 19.842 10.4393 19.5607C10.158 19.2794 10 18.8978 10 18.5ZM10 12.5C10 12.1022 10.158 11.7206 10.4393 11.4393C10.7206 11.158 11.1022 11 11.5 11C11.8978 11 12.2794 11.158 12.5607 11.4393C12.842 11.7206 13 12.1022 13 12.5C13 12.8978 12.842 13.2794 12.5607 13.5607C12.2794 13.842 11.8978 14 11.5 14C11.1022 14 10.7206 13.842 10.4393 13.5607C10.158 13.2794 10 12.8978 10 12.5ZM10 6.5C10 6.10218 10.158 5.72064 10.4393 5.43934C10.7206 5.15804 11.1022 5 11.5 5C11.8978 5 12.2794 5.15804 12.5607 5.43934C12.842 5.72064 13 6.10218 13 6.5C13 6.89782 12.842 7.27936 12.5607 7.56066C12.2794 7.84196 11.8978 8 11.5 8C11.1022 8 10.7206 7.84196 10.4393 7.56066C10.158 7.27936 10 6.89782 10 6.5Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'ant-right' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="ant-design:left-outlined">
            <path
              id="Vector"
              d="M4.68748 12.5888L4.68748 13.7966C4.68748 13.9013 4.80779 13.9591 4.88904 13.8951L11.9328 8.3935C11.9926 8.34696 12.0411 8.28736 12.0744 8.21926C12.1077 8.15115 12.125 8.07634 12.125 8.00053C12.125 7.92472 12.1077 7.8499 12.0744 7.7818C12.0411 7.7137 11.9926 7.6541 11.9328 7.60756L4.88904 2.106C4.80623 2.04194 4.68748 2.09975 4.68748 2.20444L4.68748 3.41225C4.68748 3.48881 4.72341 3.56225 4.78279 3.60912L10.4078 7.99975L4.78279 12.3919C4.72341 12.4388 4.68748 12.5122 4.68748 12.5888Z"
              fill="currentColor"
            />
          </g>
        </svg>
      )}
      {type === 'ant-left' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M11.3125 3.41119V2.20338C11.3125 2.09869 11.1922 2.04088 11.111 2.10494L4.06721 7.6065C4.00736 7.65304 3.95894 7.71264 3.92563 7.78074C3.89232 7.84885 3.875 7.92366 3.875 7.99947C3.875 8.07528 3.89232 8.1501 3.92563 8.2182C3.95894 8.2863 4.00736 8.3459 4.06721 8.39244L11.111 13.894C11.1938 13.9581 11.3125 13.9003 11.3125 13.7956V12.5878C11.3125 12.5112 11.2766 12.4378 11.2172 12.3909L5.59221 8.00025L11.2172 3.60807C11.2766 3.56119 11.3125 3.48775 11.3125 3.41119Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'arrows' && (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="arrows">
            <path
              id="cross"
              d="M7.40992 5.99967L10.9999 2.43966C11.1909 2.24606 11.2971 1.98452 11.2952 1.71259C11.2933 1.44067 11.1835 1.18062 10.9899 0.989665C10.7963 0.798709 10.5348 0.692485 10.2628 0.69436C9.99092 0.696236 9.73088 0.806057 9.53992 0.999665L5.99992 4.58967L2.45992 1.06967C2.27256 0.883415 2.0191 0.778873 1.75492 0.778873C1.49073 0.778873 1.23728 0.883415 1.04992 1.06967C0.956191 1.16263 0.881796 1.27323 0.831028 1.39509C0.780259 1.51695 0.754121 1.64765 0.754121 1.77967C0.754121 1.91168 0.780259 2.04238 0.831028 2.16424C0.881796 2.2861 0.956191 2.3967 1.04992 2.48967L4.58992 5.99967L0.999919 9.55967C0.808963 9.75327 0.702739 10.0148 0.704614 10.2867C0.70649 10.5587 0.816311 10.8187 1.00992 11.0097C1.20353 11.2006 1.46506 11.3068 1.73699 11.305C2.00892 11.3031 2.26896 11.1933 2.45992 10.9997L5.99992 7.40967L9.53992 10.9297C9.72728 11.1159 9.98073 11.2205 10.2449 11.2205C10.5091 11.2205 10.7626 11.1159 10.9499 10.9297C11.0436 10.8367 11.118 10.7261 11.1688 10.6042C11.2196 10.4824 11.2457 10.3517 11.2457 10.2197C11.2457 10.0877 11.2196 9.95695 11.1688 9.83509C11.118 9.71323 11.0436 9.60263 10.9499 9.50967L7.40992 5.99967Z"
              fill="currentColor"
            />
          </g>
        </svg>
      )}
      {type === 'group-empty' && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="Group 628893">
            <rect
              id="Rectangle 1175"
              x="0.75"
              y="0.75"
              width="16.5"
              height="16.5"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </g>
        </svg>
      )}
      {type === 'group-fill' && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="Group 628892">
            <rect
              id="Rectangle 1175"
              width="18"
              height="18"
              fill="currentColor"
            />
            <path
              id="Vector"
              d="M14.6705 6.61306L8.73563 13.1375C8.29615 13.6208 7.58324 13.6208 7.14334 13.1375L4.07974 9.76908C3.64009 9.28581 3.64009 8.50193 4.07974 8.01856C4.51947 7.53511 5.23232 7.53511 5.67186 8.01838L7.93972 10.5118L13.0781 4.86245C13.5178 4.379 14.2307 4.37937 14.6703 4.86245C15.1099 5.34582 15.1099 6.12943 14.6705 6.61306Z"
              fill="white"
            />
          </g>
        </svg>
      )}
      {type === 'ellip' && (
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <circle cx="4" cy="4" r="4" fill="currentColor" />
        </svg>
      )}
      {type === 'cross' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M13.4099 12L16.9999 8.44003C17.1909 8.24642 17.2971 7.98489 17.2952 7.71296C17.2933 7.44103 17.1835 7.18099 16.9899 6.99003C16.7963 6.79908 16.5348 6.69285 16.2628 6.69473C15.9909 6.6966 15.7309 6.80642 15.5399 7.00003L11.9999 10.59L8.45992 7.07003C8.27256 6.88378 8.0191 6.77924 7.75492 6.77924C7.49073 6.77924 7.23728 6.88378 7.04992 7.07003C6.95619 7.16299 6.8818 7.2736 6.83103 7.39546C6.78026 7.51731 6.75412 7.64802 6.75412 7.78003C6.75412 7.91204 6.78026 8.04275 6.83103 8.16461C6.8818 8.28647 6.95619 8.39707 7.04992 8.49003L10.5899 12L6.99992 15.56C6.80896 15.7536 6.70274 16.0152 6.70461 16.2871C6.70649 16.559 6.81631 16.8191 7.00992 17.01C7.20353 17.201 7.46506 17.3072 7.73699 17.3053C8.00892 17.3035 8.26896 17.1936 8.45992 17L11.9999 13.41L15.5399 16.93C15.7273 17.1163 15.9807 17.2208 16.2449 17.2208C16.5091 17.2208 16.7626 17.1163 16.9499 16.93C17.0436 16.8371 17.118 16.7265 17.1688 16.6046C17.2196 16.4827 17.2457 16.352 17.2457 16.22C17.2457 16.088 17.2196 15.9573 17.1688 15.8355C17.118 15.7136 17.0436 15.603 16.9499 15.51L13.4099 12Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'like' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M16.8915 13.5545L17.4794 10.1547C17.6263 9.3055 16.9732 8.52883 16.1124 8.52883H11.7949C11.3669 8.52883 11.0411 8.14473 11.1103 7.72198L11.6626 4.35151C11.7523 3.80395 11.7267 3.24366 11.5873 2.7066C11.4719 2.26169 11.1287 1.90445 10.6773 1.75943L10.5564 1.72062C10.2836 1.63298 9.98584 1.65337 9.72861 1.77732C9.44549 1.91375 9.23836 2.1626 9.16158 2.45857L8.76516 3.98678C8.63903 4.47302 8.4553 4.94237 8.21841 5.38584C7.87228 6.0338 7.33713 6.55238 6.78085 7.03174L5.5819 8.0649C5.24385 8.3562 5.06632 8.79246 5.10479 9.23733L5.78159 17.0646C5.84367 17.7825 6.44392 18.3337 7.16374 18.3337H11.0376C13.9387 18.3337 16.4145 16.3123 16.8915 13.5545Z"
            fill="#1F2937"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.47305 7.90391C2.80744 7.88948 3.09384 8.14103 3.12268 8.47449L3.93234 17.8383C3.98435 18.4397 3.51057 18.9582 2.90559 18.9582C2.33574 18.9582 1.875 18.4959 1.875 17.9271V8.52833C1.875 8.19363 2.13867 7.91834 2.47305 7.90391Z"
            fill="#1F2937"
          />
        </svg>
      )}
      {type === 'time' && (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="time 1" clipPath="url(#clip0_108_2203)">
            <g id="Group">
              <path
                id="Vector"
                d="M6.88086 6.84693L7.34845 7.33387C8.0241 6.77312 8.89126 6.43552 9.83585 6.43552C10.1286 6.43552 10.4139 6.46818 10.6884 6.52965C10.4676 4.55096 8.87164 2.98189 6.88086 2.80273V6.84693Z"
                fill="currentColor"
              />
              <path
                id="Vector_2"
                d="M6.81208 7.87507L6.11914 7.15344V2.80273C5.24251 2.88162 4.44245 3.22991 3.80258 3.76415L4.43498 4.39655L3.89637 4.93517L3.26397 4.30276C2.72972 4.94263 2.38144 5.74269 2.30255 6.61933H3.19879V7.38104H2.30255C2.38144 8.25768 2.72972 9.05774 3.26397 9.69761L3.87093 9.09065L4.40954 9.62926L3.80258 10.2362C4.42056 10.7522 5.18794 11.0947 6.02944 11.1886C5.96799 10.9141 5.93532 10.6288 5.93532 10.336C5.93534 9.40369 6.26433 8.54683 6.81208 7.87507Z"
                fill="currentColor"
              />
              <path
                id="Vector_3"
                d="M6.29561 11.972C3.64594 11.8644 1.52344 9.67561 1.52344 7C1.52344 4.25591 3.75591 2.02344 6.5 2.02344C9.17561 2.02344 11.3644 4.14594 11.472 6.79561C12.0471 7.06244 12.5465 7.46526 12.929 7.96263C12.9762 7.64528 13 7.32368 13 7C13 5.26379 12.3239 3.6315 11.0962 2.40379C9.8685 1.17613 8.23621 0.5 6.5 0.5C4.76379 0.5 3.1315 1.17613 1.90379 2.40379C0.676127 3.6315 0 5.26379 0 7C0 8.73621 0.676127 10.3685 1.90379 11.5962C3.1315 12.8239 4.76379 13.5 6.5 13.5C6.82368 13.5 7.14525 13.4761 7.46261 13.429C6.96526 13.0465 6.56244 12.547 6.29561 11.972Z"
                fill="currentColor"
              />
            </g>
            <g id="Group_2">
              <path
                id="Vector_4"
                d="M9.83584 7.17188C8.0911 7.17188 6.67166 8.59134 6.67166 10.3361C6.67166 12.0808 8.0911 13.5002 9.83584 13.5002C11.5806 13.5002 13 12.0808 13 10.3361C13 8.59134 11.5806 7.17188 9.83584 7.17188ZM9.83582 12.1232C9.58706 12.1232 9.38541 11.9216 9.38541 11.6728C9.38541 11.4241 9.58706 11.2224 9.83582 11.2224C10.0846 11.2224 10.2862 11.4241 10.2862 11.6728C10.2862 11.9216 10.0846 12.1232 9.83582 12.1232ZM10.1517 10.683H9.51998L9.36205 8.35495H10.3096L10.1517 10.683Z"
                fill="currentColor"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_108_2203">
              <rect
                width="13"
                height="13"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'hour' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M4.33196 2.74915C4.8338 1.6665 6.55589 1.6665 10.0001 1.6665C13.4443 1.6665 15.1664 1.6665 15.6682 2.74915C15.7113 2.84222 15.7477 2.93888 15.777 3.03825C16.1179 4.19425 14.9002 5.5341 12.4648 8.21379L10.8334 9.99984L12.4648 11.7859C14.9002 14.4656 16.1179 15.8054 15.777 16.9614C15.7477 17.0608 15.7113 17.1575 15.6682 17.2505C15.1664 18.3332 13.4443 18.3332 10.0001 18.3332C6.55589 18.3332 4.8338 18.3332 4.33196 17.2505C4.28882 17.1575 4.25243 17.0608 4.22313 16.9614C3.88222 15.8054 5.09992 14.4656 7.53533 11.7859L9.16675 9.99984L7.53533 8.21379C5.09992 5.5341 3.88222 4.19425 4.22313 3.03825C4.25243 2.93888 4.28882 2.84222 4.33196 2.74915Z"
            fill="#1C274C"
          />
        </svg>
      )}
      {type === 'completed' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.99302 2.66722C7.79008 2.84016 7.6886 2.92664 7.58023 2.99927C7.33181 3.16578 7.05283 3.28134 6.75943 3.33926C6.63144 3.36453 6.49854 3.37514 6.23275 3.39635C5.56493 3.44964 5.23102 3.47628 4.95244 3.57468C4.30811 3.80227 3.80129 4.30908 3.57371 4.95341C3.47531 5.23199 3.44866 5.56591 3.39537 6.23373C3.37416 6.49952 3.36355 6.63242 3.33828 6.76041C3.28036 7.0538 3.1648 7.33279 2.9983 7.58121C2.92566 7.68958 2.83919 7.79105 2.66624 7.994C2.23171 8.50389 2.01444 8.75885 1.88703 9.02541C1.59234 9.64195 1.59234 10.3587 1.88703 10.9752C2.01444 11.2418 2.23171 11.4968 2.66624 12.0067C2.83917 12.2096 2.92567 12.3111 2.9983 12.4194C3.1648 12.6679 3.28036 12.9468 3.33828 13.2402C3.36355 13.3682 3.37416 13.5011 3.39537 13.7669C3.44866 14.4347 3.47531 14.7687 3.57371 15.0472C3.80129 15.6916 4.30811 16.1984 4.95244 16.426C5.23102 16.5244 5.56493 16.551 6.23275 16.6043C6.49854 16.6255 6.63144 16.6361 6.75943 16.6614C7.05283 16.7193 7.33181 16.8349 7.58023 17.0014C7.6886 17.074 7.79008 17.1605 7.99302 17.3334C8.50292 17.768 8.75788 17.9852 9.02444 18.1126C9.64098 18.4073 10.3577 18.4073 10.9743 18.1126C11.2408 17.9852 11.4958 17.768 12.0057 17.3334C12.2086 17.1605 12.3101 17.074 12.4185 17.0014C12.6669 16.8349 12.9459 16.7193 13.2393 16.6614C13.3673 16.6361 13.5002 16.6255 13.7659 16.6043C14.4338 16.551 14.7677 16.5244 15.0463 16.426C15.6906 16.1984 16.1974 15.6916 16.425 15.0472C16.5234 14.7687 16.55 14.4347 16.6033 13.7669C16.6245 13.5011 16.6351 13.3682 16.6604 13.2402C16.7183 12.9468 16.8339 12.6679 17.0004 12.4194C17.073 12.3111 17.1595 12.2096 17.3325 12.0067C17.767 11.4968 17.9843 11.2418 18.1117 10.9752C18.4064 10.3587 18.4064 9.64195 18.1117 9.02542C17.9843 8.75885 17.767 8.5039 17.3325 7.994C17.1595 7.79105 17.073 7.68958 17.0004 7.58121C16.8339 7.33279 16.7183 7.0538 16.6604 6.76041C16.6351 6.63242 16.6245 6.49952 16.6033 6.23373C16.55 5.56591 16.5234 5.23199 16.425 4.95341C16.1974 4.30908 15.6906 3.80227 15.0463 3.57468C14.7677 3.47628 14.4338 3.44964 13.7659 3.39635C13.5002 3.37514 13.3673 3.36453 13.2393 3.33926C12.9459 3.28134 12.6669 3.16578 12.4185 2.99927C12.3101 2.92664 12.2086 2.84017 12.0057 2.66722C11.4958 2.23268 11.2408 2.01541 10.9743 1.88801C10.3577 1.59332 9.64098 1.59332 9.02444 1.88801C8.75788 2.01541 8.50292 2.23269 7.99302 2.66722ZM13.6439 8.21961C13.9088 7.95475 13.9088 7.52532 13.6439 7.26046C13.3791 6.9956 12.9496 6.9956 12.6848 7.26046L8.64291 11.3023L7.3139 9.97333C7.04904 9.70847 6.61962 9.70847 6.35476 9.97333C6.0899 10.2382 6.0899 10.6676 6.35476 10.9325L8.16333 12.7411C8.42819 13.0059 8.85762 13.0059 9.12248 12.7411L13.6439 8.21961Z"
            fill="#1C274C"
          />
        </svg>
      )}
      {type === 'expired' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="14"
          fill="none"
          viewBox="0 0 13 14"
          className={`${className}`}
        >
          <g fill="currentColor" clipPath="url(#clip0_5_9451)">
            <path d="M6.88 6.847l.468.487a3.883 3.883 0 013.34-.804 4.222 4.222 0 00-3.807-3.727v4.044zM6.812 7.875l-.693-.722v-4.35a4.196 4.196 0 00-2.316.961l.632.633-.539.538-.632-.632a4.196 4.196 0 00-.962 2.316H3.2v.762h-.897c.08.877.428 1.677.962 2.317l.607-.607.538.538-.606.607a4.197 4.197 0 002.226.953 3.9 3.9 0 01.783-3.314z"></path>
            <path d="M6.296 11.972A4.982 4.982 0 011.523 7 4.982 4.982 0 016.5 2.023a4.982 4.982 0 014.972 4.773c.575.266 1.075.67 1.457 1.167.047-.318.071-.64.071-.963a6.457 6.457 0 00-1.904-4.596A6.458 6.458 0 006.5.5a6.458 6.458 0 00-4.596 1.904A6.458 6.458 0 000 7c0 1.736.676 3.368 1.904 4.596A6.457 6.457 0 006.5 13.5c.324 0 .645-.024.963-.071a3.925 3.925 0 01-1.167-1.457z"></path>
            <path d="M9.836 7.172a3.168 3.168 0 00-3.164 3.164A3.168 3.168 0 009.836 13.5 3.168 3.168 0 0013 10.336a3.168 3.168 0 00-3.164-3.164zm0 4.951a.45.45 0 110-.9.45.45 0 010 .9zm.316-1.44H9.52l-.158-2.328h.947l-.157 2.328z"></path>
          </g>
          <defs>
            <clipPath id="clip0_5_9451">
              <path
                fill="#fff"
                d="M0 0H13V13H0z"
                transform="translate(0 .5)"
              ></path>
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'search' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.325 14.8992L21.705 20.2792C21.8941 20.4685 22.0003 20.7251 22.0002 20.9926C22.0001 21.2601 21.8937 21.5166 21.7045 21.7057C21.5153 21.8948 21.2587 22.001 20.9912 22.0009C20.7236 22.0008 20.4671 21.8945 20.278 21.7052L14.898 16.3252C13.2897 17.5709 11.2673 18.1571 9.24214 17.9646C7.21699 17.7721 5.34124 16.8153 3.99649 15.2888C2.65174 13.7624 1.939 11.781 2.00326 9.74778C2.06753 7.71451 2.90396 5.78209 4.34242 4.34364C5.78087 2.90518 7.71329 2.06875 9.74656 2.00448C11.7798 1.94022 13.7612 2.65296 15.2876 3.99771C16.814 5.34246 17.7708 7.21821 17.9634 9.24336C18.1559 11.2685 17.5697 13.2909 16.324 14.8992H16.325ZM10 16.0002C11.5913 16.0002 13.1174 15.3681 14.2427 14.2429C15.3679 13.1177 16 11.5915 16 10.0002C16 8.40893 15.3679 6.88281 14.2427 5.75759C13.1174 4.63237 11.5913 4.00023 10 4.00023C8.40871 4.00023 6.88259 4.63237 5.75737 5.75759C4.63215 6.88281 4.00001 8.40893 4.00001 10.0002C4.00001 11.5915 4.63215 13.1177 5.75737 14.2429C6.88259 15.3681 8.40871 16.0002 10 16.0002Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'play-circle-sharp' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100"
          height="100"
          fill="none"
          viewBox="0 0 100 100"
          className={`${className}`}
        >
          <g>
            <path
              fill="currentColor"
              d="M50 9.375C27.6 9.375 9.375 27.6 9.375 50S27.6 90.625 50 90.625 90.625 72.4 90.625 50 72.4 9.375 50 9.375zM39.062 67.188V32.812L67.189 50 39.061 67.188z"
            ></path>
          </g>
        </svg>
      )}
      {type === 'learning-resource' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M21.938 2.25H2.063a.563.563 0 00-.563.563v2.624c0 .311.252.563.563.563h19.875c.31 0 .562-.252.562-.563V2.813a.562.562 0 00-.563-.562zM3 7.5v13.125a1.125 1.125 0 001.125 1.125h15.75A1.125 1.125 0 0021 20.625V7.5H3zm9 10.81l-4.063-4.06L9 13.187l2.25 2.252V9.75h1.5v5.69l2.253-2.254 1.06 1.061L12 18.311z"
          ></path>
        </svg>
      )}
      {type === 'entrance-test' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M7.5 11.25H14.408L11.408 8.25L12.4688 7.18922L17.2795 12L12.4688 16.8108L11.408 15.75L14.408 12.75H7.5V19.6875C7.5 19.8367 7.55926 19.9798 7.66475 20.0852C7.77024 20.1907 7.91332 20.25 8.0625 20.25H21.9375C22.0867 20.25 22.2298 20.1907 22.3352 20.0852C22.4407 19.9798 22.5 19.8367 22.5 19.6875V4.3125C22.5 4.16332 22.4407 4.02024 22.3352 3.91475C22.2298 3.80926 22.0867 3.75 21.9375 3.75H8.0625C7.91332 3.75 7.77024 3.80926 7.66475 3.91475C7.55926 4.02024 7.5 4.16332 7.5 4.3125V11.25Z"
            fill="currentColor"
            className="group-resource"
          />
          <path
            d="M7.5 11.25H1.5V12.75H7.5V11.25Z"
            fill="currentColor"
            className="group-resource"
          />
        </svg>
      )}

      {type === 'event-test' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            className="group-resource"
            d="M3.75 1.5L0.75 7.5H14.302L18.0623 1.5H3.75Z"
            fill="currentColor"
          />
          <path
            className="group-resource"
            d="M23.2501 6.75L19.8751 1.5L13.9689 10.8319C12.6938 10.3889 11.3065 10.3889 10.0314 10.8319L8.88436 9H2.0542L6.11639 15.323C5.94174 16.1936 5.96253 17.0922 6.17725 17.9538C6.39197 18.8155 6.79528 19.6187 7.35806 20.3056C7.92085 20.9925 8.62909 21.5459 9.43168 21.9259C10.2343 22.3059 11.1112 22.503 11.9992 22.503C12.8872 22.503 13.7641 22.3059 14.5667 21.9259C15.3693 21.5459 16.0775 20.9925 16.6403 20.3056C17.2031 19.6187 17.6064 18.8155 17.8212 17.9538C18.0359 17.0922 18.0567 16.1936 17.882 15.323L23.2501 6.75ZM12.0001 19.7812C11.3512 19.7812 10.7168 19.5888 10.1772 19.2283C9.63757 18.8677 9.21701 18.3552 8.96866 17.7557C8.72031 17.1561 8.65533 16.4964 8.78194 15.8599C8.90854 15.2234 9.22105 14.6387 9.67994 14.1798C10.1388 13.7209 10.7235 13.4084 11.36 13.2818C11.9965 13.1552 12.6562 13.2202 13.2558 13.4685C13.8554 13.7169 14.3678 14.1374 14.7284 14.677C15.0889 15.2166 15.2814 15.851 15.2814 16.5C15.2804 17.3699 14.9344 18.204 14.3192 18.8191C13.7041 19.4342 12.8701 19.7803 12.0001 19.7812Z"
            fill="currentColor"
          />
          <path
            className="group-resource"
            d="M12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z"
            fill="currentColor"
          />
        </svg>
      )}

      {type === 'circle' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={`${className}`}
        >
          <circle cx="8" cy="8" r="8" fill="currentColor" />
        </svg>
      )}

      {type === 'arrow-bottom' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            stroke="currentColor"
            strokeLinecap="square"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M19 9.391l-7 7.305L5 9.39"
          ></path>
        </svg>
      )}
      {type === 'volume' && (
        <svg
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
          viewBox="0 0 16 16"
        >
          <g fill="#fff" clipPath="url(#clip0_246_5900)">
            <path d="M9.298.586a.532.532 0 00-.564.064L3.546 4.8h-2.48C.48 4.8 0 5.28 0 5.867v4.267c0 .588.479 1.066 1.067 1.066h2.479l5.187 4.15a.539.539 0 00.565.064.532.532 0 00.302-.48V1.067a.535.535 0 00-.302-.481zM12.3 4.229a.535.535 0 00-.75.759A4.197 4.197 0 0112.8 8a4.197 4.197 0 01-1.25 3.013.534.534 0 10.75.757A5.246 5.246 0 0013.867 8 5.254 5.254 0 0012.3 4.23z"></path>
            <path d="M13.805 2.726a.534.534 0 00-.752.757A6.315 6.315 0 0114.933 8c0 1.711-.668 3.314-1.88 4.517a.536.536 0 00-.004.755.536.536 0 00.756.002A7.367 7.367 0 0016 8c0-1.998-.779-3.87-2.195-5.274z"></path>
          </g>
          <defs>
            <clipPath id="clip0_246_5900">
              <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
          </defs>
        </svg>
      )}
      {type === 'fullscreen' && (
        <svg
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="23"
          viewBox="0 0 23 23"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.40662 1.34814L9.45833 1.34815C9.83803 1.34815 10.1458 1.65595 10.1458 2.03565C10.1458 2.41534 9.83803 2.72315 9.45833 2.72315C7.71041 2.72315 6.46864 2.72461 5.52661 2.85126C4.60436 2.97525 4.07302 3.20778 3.68508 3.59572C3.29714 3.98367 3.06461 4.51501 2.94061 5.43726C2.81396 6.37928 2.8125 7.62106 2.8125 9.36898C2.8125 9.74867 2.5047 10.0565 2.125 10.0565C1.7453 10.0565 1.4375 9.74867 1.4375 9.36898L1.4375 9.31726C1.43749 7.63265 1.43747 6.29832 1.57787 5.25404C1.72237 4.17932 2.02681 3.30945 2.71281 2.62345C3.39881 1.93745 4.26868 1.63301 5.3434 1.48852C6.38768 1.34812 7.722 1.34813 9.40662 1.34814ZM17.0567 2.85126C16.1147 2.72461 14.8729 2.72315 13.125 2.72315C12.7453 2.72315 12.4375 2.41534 12.4375 2.03565C12.4375 1.65595 12.7453 1.34815 13.125 1.34815L13.1767 1.34814C14.8613 1.34813 16.1957 1.34812 17.2399 1.48852C18.3147 1.63301 19.1845 1.93745 19.8705 2.62345C20.5565 3.30945 20.861 4.17932 21.0055 5.25404C21.1459 6.29832 21.1458 7.63265 21.1458 9.31727V9.36898C21.1458 9.74867 20.838 10.0565 20.4583 10.0565C20.0786 10.0565 19.7708 9.74867 19.7708 9.36898C19.7708 7.62106 19.7694 6.37928 19.6427 5.43726C19.5187 4.51501 19.2862 3.98367 18.8983 3.59572C18.5103 3.20778 17.979 2.97525 17.0567 2.85126ZM2.125 12.3481C2.5047 12.3481 2.8125 12.656 2.8125 13.0356C2.8125 14.7836 2.81396 16.0253 2.94061 16.9674C3.06461 17.8896 3.29714 18.421 3.68508 18.8089C4.07302 19.1968 4.60436 19.4294 5.52661 19.5534C6.46864 19.68 7.71041 19.6815 9.45833 19.6815C9.83803 19.6815 10.1458 19.9893 10.1458 20.369C10.1458 20.7487 9.83803 21.0565 9.45833 21.0565H9.40662C7.72201 21.0565 6.38768 21.0565 5.3434 20.9161C4.26868 20.7716 3.39881 20.4672 2.71281 19.7812C2.02681 19.0952 1.72237 18.2253 1.57787 17.1506C1.43747 16.1063 1.43749 14.772 1.4375 13.0874L1.4375 13.0356C1.4375 12.656 1.7453 12.3481 2.125 12.3481ZM20.4583 12.3481C20.838 12.3481 21.1458 12.656 21.1458 13.0356V13.0874C21.1458 14.772 21.1459 16.1063 21.0055 17.1506C20.861 18.2253 20.5565 19.0952 19.8705 19.7812C19.1845 20.4672 18.3147 20.7716 17.2399 20.9161C16.1957 21.0565 14.8613 21.0565 13.1767 21.0565H13.125C12.7453 21.0565 12.4375 20.7487 12.4375 20.369C12.4375 19.9893 12.7453 19.6815 13.125 19.6815C14.8729 19.6815 16.1147 19.68 17.0567 19.5534C17.979 19.4294 18.5103 19.1968 18.8983 18.8089C19.2862 18.421 19.5187 17.8896 19.6427 16.9674C19.7694 16.0253 19.7708 14.7836 19.7708 13.0356C19.7708 12.656 20.0786 12.3481 20.4583 12.3481Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'close' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            d="M18 18L6 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 18L18 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {type === 'arrow-right' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4697 5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967L20.5303 11.4697C20.8232 11.7626 20.8232 12.2374 20.5303 12.5303L14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303C13.1768 18.2374 13.1768 17.7626 13.4697 17.4697L18.1893 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H18.1893L13.4697 6.53033C13.1768 6.23744 13.1768 5.76256 13.4697 5.46967Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'my-profile' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.25 9C8.25 6.92893 9.92893 5.25 12 5.25C14.0711 5.25 15.75 6.92893 15.75 9C15.75 11.0711 14.0711 12.75 12 12.75C9.92893 12.75 8.25 11.0711 8.25 9ZM12 6.75C10.7574 6.75 9.75 7.75736 9.75 9C9.75 10.2426 10.7574 11.25 12 11.25C13.2426 11.25 14.25 10.2426 14.25 9C14.25 7.75736 13.2426 6.75 12 6.75Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 14.5456 3.77827 16.851 5.4421 18.5235C5.6225 17.5504 5.97694 16.6329 6.68837 15.8951C7.75252 14.7915 9.45416 14.25 12 14.25C14.5457 14.25 16.2474 14.7915 17.3115 15.8951C18.023 16.6329 18.3774 17.5505 18.5578 18.5236C20.2217 16.8511 21.25 14.5456 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM17.1937 19.6554C17.0918 18.4435 16.8286 17.5553 16.2318 16.9363C15.5823 16.2628 14.3789 15.75 12 15.75C9.62099 15.75 8.41761 16.2628 7.76815 16.9363C7.17127 17.5553 6.90811 18.4434 6.80622 19.6553C8.28684 20.6618 10.0747 21.25 12 21.25C13.9252 21.25 15.7131 20.6618 17.1937 19.6554Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'certificates' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.94513 1.25H16.0549C17.4225 1.24998 18.5248 1.24996 19.3918 1.36652C20.2919 1.48754 21.0497 1.74643 21.6517 2.34835C22.2536 2.95027 22.5125 3.70814 22.6335 4.60825C22.75 5.47522 22.75 6.57754 22.75 7.94513V12.0549C22.75 13.4225 22.75 14.5248 22.6335 15.3918C22.5125 16.2919 22.2536 17.0497 21.6517 17.6516C21.1537 18.1496 20.5469 18.4146 19.8361 18.5593C19.4739 18.6331 19.0724 18.6779 18.6302 18.7053C18.6324 18.7104 18.6347 18.7155 18.6369 18.7207C18.9098 19.361 18.6769 20.1059 18.057 20.4572C17.8707 20.5629 17.6702 20.6009 17.5301 20.6227C17.3836 20.6454 17.2006 20.6633 16.9974 20.6832L16.9776 20.6851C16.8468 20.6979 16.7726 20.7053 16.7175 20.7132C16.6924 20.7168 16.6791 20.7194 16.6739 20.7206C16.6583 20.7267 16.6477 20.7343 16.6409 20.7408C16.6358 20.7457 16.6321 20.7506 16.6294 20.7557C16.6282 20.7613 16.6265 20.7704 16.6244 20.7839C16.6166 20.8342 16.6091 20.903 16.5957 21.0292L16.5935 21.0498C16.5729 21.2432 16.554 21.421 16.5298 21.5641C16.5066 21.702 16.4648 21.9054 16.3486 22.0938C15.9743 22.7006 15.2273 22.8883 14.6126 22.6475C14.4208 22.5723 14.2668 22.4498 14.1557 22.3543C14.0419 22.2565 13.9078 22.1279 13.7577 21.984L12 20.2989L10.2424 21.984C10.0922 22.1279 9.95813 22.2565 9.84431 22.3543C9.73321 22.4498 9.57925 22.5723 9.38737 22.6475C8.77269 22.8883 8.02567 22.7006 7.6514 22.0938C7.53523 21.9054 7.49345 21.702 7.47018 21.5641C7.44605 21.421 7.42711 21.2431 7.40651 21.0497L7.40432 21.0292C7.39088 20.903 7.38336 20.8342 7.37555 20.7839C7.37346 20.7704 7.37178 20.7613 7.37065 20.7557C7.36789 20.7506 7.36415 20.7457 7.35908 20.7408C7.35227 20.7343 7.34174 20.7267 7.32614 20.7206C7.32086 20.7194 7.30762 20.7168 7.28255 20.7132C7.22741 20.7053 7.15319 20.6979 7.02244 20.6851L7.00262 20.6832C6.79938 20.6633 6.61637 20.6454 6.46992 20.6227C6.32977 20.6009 6.12935 20.5629 5.94298 20.4572C5.32307 20.1059 5.09019 19.361 5.36311 18.7207C5.36532 18.7155 5.36757 18.7104 5.36985 18.7052C4.97118 18.6805 4.60714 18.6418 4.27635 18.5811C3.51836 18.4418 2.87328 18.1766 2.34835 17.6517C1.74643 17.0497 1.48754 16.2919 1.36652 15.3918C1.24996 14.5248 1.24998 13.4225 1.25 12.0549V7.94513C1.24998 6.57754 1.24996 5.47522 1.36652 4.60825C1.48754 3.70814 1.74643 2.95027 2.34835 2.34835C2.95027 1.74643 3.70814 1.48754 4.60825 1.36652C5.47522 1.24996 6.57754 1.24998 7.94513 1.25ZM6.7329 17.2462L7.5487 16.4641L8.25788 15.7549C8.38413 13.7981 10.0113 12.25 12 12.25C13.9887 12.25 15.6159 13.7981 15.7421 15.7549L16.4513 16.4641L17.3122 17.2894L17.3117 17.2458C18.2984 17.2353 19.0017 17.1984 19.5368 17.0895C20.0513 16.9847 20.359 16.8229 20.591 16.591C20.8678 16.3142 21.0482 15.9257 21.1469 15.1919C21.2484 14.4365 21.25 13.4354 21.25 12V8C21.25 6.56458 21.2484 5.56347 21.1469 4.80812C21.0482 4.07435 20.8678 3.68577 20.591 3.40901C20.3142 3.13225 19.9257 2.9518 19.1919 2.85315C18.4365 2.75159 17.4354 2.75 16 2.75H8C6.56458 2.75 5.56347 2.75159 4.80812 2.85315C4.07435 2.9518 3.68577 3.13225 3.40901 3.40901C3.13225 3.68577 2.9518 4.07435 2.85315 4.80812C2.75159 5.56347 2.75 6.56459 2.75 8V12C2.75 13.4354 2.75159 14.4365 2.85315 15.1919C2.9518 15.9257 3.13225 16.3142 3.40901 16.591C3.65246 16.8344 3.98054 17.0016 4.54735 17.1057C5.08573 17.2046 5.78062 17.2368 6.7329 17.2462ZM15.4159 17.5495C15.0094 18.4444 14.2614 19.1513 13.3384 19.5041L14.7819 20.888C14.9099 21.0107 15.0009 21.0977 15.0719 21.1622C15.081 21.0864 15.0912 20.9919 15.1041 20.8702C15.1059 20.8537 15.1076 20.8368 15.1094 20.8197C15.1285 20.636 15.1511 20.4185 15.2269 20.2221C15.3949 19.7871 15.7449 19.4585 16.1765 19.3054C16.3708 19.2364 16.5859 19.2158 16.7795 19.1973C16.7969 19.1956 16.8143 19.1939 16.8314 19.1922C16.9388 19.1817 17.0267 19.1731 17.1 19.1652C17.043 19.1094 16.973 19.0423 16.8857 18.9586L15.4159 17.5495ZM12.0301 18.2498L12 18.2209L11.9699 18.2498C10.7411 18.2337 9.75 17.2326 9.75 16C9.75 14.7574 10.7574 13.75 12 13.75C13.2426 13.75 14.25 14.7574 14.25 16C14.25 17.2326 13.2589 18.2337 12.0301 18.2498ZM10.6616 19.5041L9.21809 20.888C9.09009 21.0107 8.99913 21.0977 8.92814 21.1622C8.91902 21.0864 8.90885 20.9919 8.89588 20.8702C8.89412 20.8537 8.89237 20.8368 8.89059 20.8197C8.87152 20.636 8.84895 20.4185 8.7731 20.2221C8.60513 19.7871 8.25507 19.4585 7.82352 19.3054C7.62918 19.2364 7.41411 19.2158 7.22052 19.1973C7.20304 19.1956 7.18573 19.1939 7.16863 19.1922C7.0612 19.1817 6.97333 19.1731 6.90005 19.1652C6.95701 19.1094 7.02695 19.0423 7.11427 18.9586L8.58407 17.5495C8.99065 18.4444 9.73856 19.1513 10.6616 19.5041ZM8.25 6C8.25 5.58579 8.58579 5.25 9 5.25H15C15.4142 5.25 15.75 5.58579 15.75 6C15.75 6.41421 15.4142 6.75 15 6.75H9C8.58579 6.75 8.25 6.41421 8.25 6ZM6.25 9.5C6.25 9.08579 6.58579 8.75 7 8.75H17C17.4142 8.75 17.75 9.08579 17.75 9.5C17.75 9.91422 17.4142 10.25 17 10.25H7C6.58579 10.25 6.25 9.91422 6.25 9.5Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'setting' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9985 8.25C9.92747 8.25 8.24854 9.92893 8.24854 12C8.24854 14.0711 9.92747 15.75 11.9985 15.75C14.0696 15.75 15.7485 14.0711 15.7485 12C15.7485 9.92893 14.0696 8.25 11.9985 8.25ZM9.74854 12C9.74854 10.7574 10.7559 9.75 11.9985 9.75C13.2412 9.75 14.2485 10.7574 14.2485 12C14.2485 13.2426 13.2412 14.25 11.9985 14.25C10.7559 14.25 9.74854 13.2426 9.74854 12Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9733 1.25C11.5288 1.24999 11.1578 1.24999 10.8532 1.27077C10.5361 1.29241 10.2365 1.33905 9.94615 1.45933C9.27232 1.73844 8.73697 2.27379 8.45786 2.94762C8.31255 3.29842 8.2732 3.66812 8.25817 4.06996C8.2461 4.39299 8.08307 4.66251 7.84249 4.80141C7.6019 4.94031 7.28698 4.94673 7.0012 4.79568C6.64567 4.60777 6.30582 4.45699 5.92937 4.40743C5.20626 4.31223 4.47496 4.50819 3.89633 4.95219C3.64696 5.14353 3.45681 5.3796 3.27952 5.6434C3.10921 5.89681 2.9237 6.21815 2.70148 6.60307L2.67622 6.64681C2.45399 7.03172 2.26846 7.35304 2.13416 7.62723C1.99434 7.91267 1.88497 8.19539 1.84395 8.50701C1.74875 9.23012 1.9447 9.96142 2.3887 10.5401C2.61982 10.8412 2.92026 11.0602 3.2607 11.2741C3.53448 11.4461 3.68641 11.7221 3.6864 12C3.68638 12.2778 3.53446 12.5538 3.26071 12.7258C2.92023 12.9397 2.61974 13.1587 2.3886 13.4599C1.9446 14.0385 1.74865 14.7698 1.84385 15.4929C1.88488 15.8045 1.99425 16.0873 2.13406 16.3727C2.26836 16.6469 2.45388 16.9682 2.67611 17.3531L2.70138 17.3969C2.9236 17.7818 3.10912 18.1031 3.27942 18.3565C3.45671 18.6203 3.64687 18.8564 3.89623 19.0477C4.47486 19.4917 5.20616 19.6877 5.92927 19.5925C6.3057 19.5429 6.64553 19.3922 7.00104 19.2043C7.28686 19.0532 7.60182 19.0596 7.84244 19.1986C8.08305 19.3375 8.24609 19.607 8.25818 19.9301C8.27321 20.3319 8.31256 20.7016 8.45786 21.0524C8.73697 21.7262 9.27232 22.2616 9.94615 22.5407C10.2365 22.661 10.5361 22.7076 10.8532 22.7292C11.1578 22.75 11.5288 22.75 11.9733 22.75H12.0238C12.4682 22.75 12.8393 22.75 13.1439 22.7292C13.461 22.7076 13.7605 22.661 14.0509 22.5407C14.7247 22.2616 15.2601 21.7262 15.5392 21.0524C15.6845 20.7016 15.7239 20.3319 15.7389 19.93C15.751 19.607 15.914 19.3375 16.1546 19.1985C16.3952 19.0596 16.7101 19.0532 16.996 19.2042C17.3514 19.3921 17.6913 19.5429 18.0677 19.5924C18.7908 19.6876 19.5221 19.4917 20.1007 19.0477C20.3501 18.8563 20.5402 18.6203 20.7175 18.3565C20.8878 18.1031 21.0733 17.7818 21.2955 17.3969L21.3208 17.3531C21.543 16.9682 21.7286 16.6468 21.8629 16.3726C22.0027 16.0872 22.1121 15.8045 22.1531 15.4929C22.2483 14.7697 22.0524 14.0384 21.6084 13.4598C21.3772 13.1586 21.0768 12.9397 20.7363 12.7258C20.4625 12.5538 20.3106 12.2778 20.3107 11.9999C20.3107 11.7221 20.4626 11.4462 20.7363 11.2742C21.0768 11.0603 21.3773 10.8414 21.6085 10.5401C22.0524 9.96149 22.2484 9.23019 22.1532 8.50708C22.1122 8.19546 22.0028 7.91274 21.863 7.6273C21.7287 7.35313 21.5432 7.03183 21.321 6.64695L21.2957 6.60318C21.0735 6.21825 20.8879 5.89688 20.7176 5.64347C20.5403 5.37967 20.3502 5.1436 20.1008 4.95225C19.5222 4.50826 18.7909 4.3123 18.0678 4.4075C17.6913 4.45706 17.3515 4.60782 16.996 4.79572C16.7102 4.94679 16.3952 4.94036 16.1546 4.80144C15.914 4.66253 15.751 4.39297 15.7389 4.06991C15.7238 3.66808 15.6845 3.2984 15.5392 2.94762C15.2601 2.27379 14.7247 1.73844 14.0509 1.45933C13.7605 1.33905 13.461 1.29241 13.1439 1.27077C12.8393 1.24999 12.4682 1.24999 12.0238 1.25H11.9733ZM10.5202 2.84515C10.5973 2.81319 10.7145 2.78372 10.9553 2.76729C11.2027 2.75041 11.5223 2.75 11.9985 2.75C12.4747 2.75 12.7943 2.75041 13.0418 2.76729C13.2825 2.78372 13.3997 2.81319 13.4769 2.84515C13.7832 2.97202 14.0265 3.21536 14.1534 3.52165C14.1934 3.61826 14.2266 3.76887 14.2399 4.12597C14.2696 4.91835 14.6785 5.68129 15.4046 6.10048C16.1307 6.51968 16.9959 6.4924 17.6969 6.12188C18.0129 5.9549 18.1599 5.90832 18.2636 5.89467C18.5923 5.8514 18.9247 5.94047 19.1877 6.14228C19.2539 6.19312 19.3381 6.27989 19.4727 6.48016C19.611 6.68603 19.7712 6.9626 20.0093 7.375C20.2474 7.78741 20.4068 8.06438 20.5159 8.28713C20.6221 8.50382 20.6551 8.62007 20.666 8.70287C20.7093 9.03155 20.6202 9.36397 20.4184 9.62698C20.3548 9.70995 20.2409 9.81399 19.9383 10.0041C19.2669 10.426 18.8107 11.1616 18.8107 11.9999C18.8106 12.8383 19.2668 13.574 19.9383 13.9959C20.2408 14.186 20.3547 14.29 20.4183 14.373C20.6201 14.636 20.7092 14.9684 20.6659 15.2971C20.655 15.3799 20.622 15.4961 20.5158 15.7128C20.4067 15.9355 20.2473 16.2125 20.0092 16.6249C19.7711 17.0373 19.6109 17.3139 19.4726 17.5198C19.338 17.72 19.2538 17.8068 19.1876 17.8576C18.9246 18.0595 18.5922 18.1485 18.2635 18.1053C18.1598 18.0916 18.0128 18.045 17.6969 17.8781C16.9958 17.5075 16.1305 17.4803 15.4045 17.8995C14.6785 18.3187 14.2696 19.0816 14.2399 19.874C14.2266 20.2311 14.1934 20.3817 14.1534 20.4784C14.0265 20.7846 13.7832 21.028 13.4769 21.1549C13.3997 21.1868 13.2825 21.2163 13.0418 21.2327C12.7943 21.2496 12.4747 21.25 11.9985 21.25C11.5223 21.25 11.2027 21.2496 10.9553 21.2327C10.7145 21.2163 10.5973 21.1868 10.5202 21.1549C10.2139 21.028 9.97054 20.7846 9.84368 20.4784C9.80366 20.3817 9.77048 20.2311 9.75713 19.874C9.72749 19.0817 9.3185 18.3187 8.59244 17.8995C7.86637 17.4803 7.00115 17.5076 6.30012 17.8781C5.98418 18.0451 5.83716 18.0917 5.73348 18.1053C5.4048 18.1486 5.07238 18.0595 4.80937 17.8577C4.74312 17.8069 4.65898 17.7201 4.52439 17.5198C4.38604 17.314 4.22589 17.0374 3.98779 16.625C3.74969 16.2126 3.59025 15.9356 3.48114 15.7129C3.375 15.4962 3.34192 15.3799 3.33102 15.2971C3.28775 14.9684 3.37681 14.636 3.57863 14.373C3.64229 14.2901 3.75614 14.186 4.05873 13.9959C4.73012 13.5741 5.18635 12.8384 5.1864 12.0001C5.18644 11.1616 4.73019 10.4259 4.05875 10.004C3.75622 9.81389 3.64238 9.70987 3.57873 9.62691C3.37691 9.3639 3.28784 9.03149 3.33112 8.7028C3.34202 8.62001 3.3751 8.50375 3.48123 8.28707C3.59034 8.06431 3.74979 7.78734 3.98789 7.37493C4.22599 6.96253 4.38614 6.68596 4.52449 6.48009C4.65908 6.27983 4.74322 6.19305 4.80947 6.14222C5.07248 5.9404 5.40489 5.85133 5.73358 5.8946C5.83727 5.90825 5.9843 5.95483 6.30027 6.12184C7.00127 6.49235 7.86645 6.51962 8.59248 6.10045C9.31852 5.68128 9.7275 4.91837 9.75713 4.12602C9.77048 3.76889 9.80366 3.61827 9.84368 3.52165C9.97054 3.21536 10.2139 2.97202 10.5202 2.84515Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'sercurity' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4489 6.77754C11.6708 6.68322 10.8555 6.83147 10.1253 7.25308C8.33189 8.28848 7.71744 10.5816 8.75284 12.375C9.31127 13.3422 10.2356 13.9665 11.25 14.174V16.5002C11.25 16.9145 11.5858 17.2502 12 17.2502C12.4142 17.2502 12.75 16.9145 12.75 16.5002V14.175C13.1356 14.0963 13.5152 13.955 13.8748 13.7474C14.605 13.3258 15.141 12.6939 15.4484 11.9728C15.8943 10.927 15.8608 9.68827 15.2472 8.62549C14.6336 7.56272 13.5776 6.91434 12.4489 6.77754ZM10.8753 8.55212C11.3146 8.29848 11.8017 8.21007 12.2684 8.26664C12.9489 8.34912 13.5804 8.73856 13.9481 9.37549C14.3159 10.0124 14.3374 10.754 14.0686 11.3846C13.8842 11.817 13.5641 12.1947 13.1248 12.4484C12.0488 13.0695 10.6731 12.7009 10.0519 11.625C9.43069 10.5491 9.79933 9.1733 10.8753 8.55212Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1.25C11.0625 1.25 10.1673 1.55658 8.72339 2.05112L7.99595 2.30014C6.51462 2.8072 5.3714 3.19852 4.55303 3.53099C4.14078 3.69846 3.78637 3.86067 3.50098 4.02641C3.22634 4.1859 2.95082 4.38484 2.76363 4.65154C2.5786 4.91516 2.48293 5.23924 2.42281 5.55122C2.36031 5.87556 2.32262 6.26464 2.2983 6.71136C2.25 7.59836 2.25 8.81351 2.25 10.3896V11.9914C2.25 18.0924 6.85803 21.0175 9.59833 22.2146L9.62543 22.2264C9.96523 22.3749 10.2846 22.5144 10.6516 22.6084C11.0391 22.7076 11.4507 22.75 12 22.75C12.5493 22.75 12.9609 22.7076 13.3484 22.6084C13.7154 22.5144 14.0348 22.3749 14.3745 22.2264L14.4017 22.2146C17.142 21.0175 21.75 18.0924 21.75 11.9914V10.3898C21.75 8.81361 21.75 7.5984 21.7017 6.71136C21.6774 6.26464 21.6397 5.87556 21.5772 5.55122C21.5171 5.23924 21.4214 4.91516 21.2364 4.65154C21.0492 4.38484 20.7737 4.1859 20.499 4.02641C20.2136 3.86067 19.8592 3.69846 19.447 3.53099C18.6286 3.19852 17.4854 2.8072 16.004 2.30013L15.2766 2.05112C13.8327 1.55658 12.9375 1.25 12 1.25ZM9.08062 3.5143C10.6951 2.96164 11.3423 2.75 12 2.75C12.6577 2.75 13.3049 2.96164 14.9194 3.5143L15.4922 3.71037C17.0048 4.22814 18.1079 4.60605 18.8824 4.92069C19.269 5.07774 19.5491 5.20935 19.7457 5.32353C19.8428 5.3799 19.9097 5.42642 19.9543 5.46273C19.9922 5.49349 20.0066 5.51092 20.0087 5.51348C20.0106 5.5166 20.0231 5.53737 20.0406 5.58654C20.0606 5.64265 20.0827 5.72309 20.1043 5.83506C20.148 6.06169 20.1811 6.37301 20.2039 6.79292C20.2497 7.63411 20.25 8.80833 20.25 10.4167V11.9914C20.25 17.1665 16.3801 19.7135 13.8012 20.84C13.4297 21.0023 13.2152 21.0941 12.9764 21.1552C12.7483 21.2136 12.47 21.25 12 21.25C11.53 21.25 11.2517 21.2136 11.0236 21.1552C10.7848 21.0941 10.5703 21.0023 10.1988 20.84C7.6199 19.7135 3.75 17.1665 3.75 11.9914V10.4167C3.75 8.80833 3.75028 7.63411 3.79608 6.79292C3.81894 6.37301 3.85204 6.06169 3.89571 5.83506C3.91729 5.72309 3.93944 5.64265 3.95943 5.58654C3.97693 5.5374 3.98936 5.51663 3.99129 5.51349C3.99336 5.51095 4.0078 5.49351 4.04567 5.46273C4.09034 5.42642 4.15722 5.3799 4.25429 5.32353C4.4509 5.20935 4.731 5.07774 5.11759 4.92069C5.8921 4.60605 6.99521 4.22814 8.5078 3.71037L9.08062 3.5143Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'logout' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            d="M14.9453 1.25C13.5778 1.24998 12.4754 1.24996 11.6085 1.36652C10.7084 1.48754 9.95048 1.74643 9.34857 2.34835C8.82363 2.87328 8.55839 3.51836 8.41916 4.27635C8.28387 5.01291 8.25799 5.9143 8.25196 6.99583C8.24966 7.41003 8.58357 7.74768 8.99778 7.74999C9.41199 7.7523 9.74964 7.41838 9.75194 7.00418C9.75803 5.91068 9.78643 5.1356 9.89448 4.54735C9.99859 3.98054 10.1658 3.65246 10.4092 3.40901C10.686 3.13225 11.0746 2.9518 11.8083 2.85315C12.5637 2.75159 13.5648 2.75 15.0002 2.75H16.0002C17.4356 2.75 18.4367 2.75159 19.1921 2.85315C19.9259 2.9518 20.3144 3.13225 20.5912 3.40901C20.868 3.68577 21.0484 4.07435 21.1471 4.80812C21.2486 5.56347 21.2502 6.56459 21.2502 8V16C21.2502 17.4354 21.2486 18.4365 21.1471 19.1919C21.0484 19.9257 20.868 20.3142 20.5912 20.591C20.3144 20.8678 19.9259 21.0482 19.1921 21.1469C18.4367 21.2484 17.4356 21.25 16.0002 21.25H15.0002C13.5648 21.25 12.5637 21.2484 11.8083 21.1469C11.0746 21.0482 10.686 20.8678 10.4092 20.591C10.1658 20.3475 9.99859 20.0195 9.89448 19.4527C9.78643 18.8644 9.75803 18.0893 9.75194 16.9958C9.74964 16.5816 9.41199 16.2477 8.99778 16.25C8.58357 16.2523 8.24966 16.59 8.25196 17.0042C8.25799 18.0857 8.28387 18.9871 8.41916 19.7236C8.55839 20.4816 8.82363 21.1267 9.34857 21.6517C9.95048 22.2536 10.7084 22.5125 11.6085 22.6335C12.4754 22.75 13.5778 22.75 14.9453 22.75H16.0551C17.4227 22.75 18.525 22.75 19.392 22.6335C20.2921 22.5125 21.0499 22.2536 21.6519 21.6517C22.2538 21.0497 22.5127 20.2919 22.6337 19.3918C22.7503 18.5248 22.7502 17.4225 22.7502 16.0549V7.94513C22.7502 6.57754 22.7503 5.47522 22.6337 4.60825C22.5127 3.70814 22.2538 2.95027 21.6519 2.34835C21.0499 1.74643 20.2921 1.48754 19.392 1.36652C18.525 1.24996 17.4227 1.24998 16.0551 1.25H14.9453Z"
            fill="currentColor"
          />
          <path
            d="M15 11.25C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H4.02744L5.98809 14.4306C6.30259 14.7001 6.33901 15.1736 6.06944 15.4881C5.79988 15.8026 5.3264 15.839 5.01191 15.5694L1.51191 12.5694C1.34567 12.427 1.25 12.2189 1.25 12C1.25 11.7811 1.34567 11.573 1.51191 11.4306L5.01191 8.43056C5.3264 8.16099 5.79988 8.19741 6.06944 8.51191C6.33901 8.8264 6.30259 9.29988 5.98809 9.56944L4.02744 11.25H15Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'phone-ring' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            d="M13.2596 1.87983C13.3258 1.47094 13.7124 1.19357 14.1212 1.25976C14.1466 1.26461 14.228 1.27983 14.2707 1.28933C14.356 1.30834 14.475 1.33759 14.6234 1.38082C14.9202 1.46726 15.3348 1.60967 15.8324 1.8378C16.8287 2.29456 18.1545 3.09356 19.5303 4.46936C20.9061 5.84516 21.7051 7.17097 22.1619 8.16725C22.39 8.66487 22.5324 9.07947 22.6188 9.37625C22.6621 9.52466 22.6913 9.64369 22.7103 9.72901C22.7198 9.77168 22.7268 9.80594 22.7316 9.83125L22.7374 9.86245C22.8036 10.2713 22.5287 10.6739 22.1198 10.7401C21.7121 10.8061 21.328 10.53 21.2602 10.1231C21.2581 10.1121 21.2524 10.0828 21.2462 10.0551C21.2339 9.9997 21.2125 9.91188 21.1787 9.79572C21.111 9.56339 20.9935 9.21806 20.7983 8.79238C20.4085 7.94207 19.7075 6.76789 18.4696 5.53002C17.2318 4.29216 16.0576 3.59117 15.2073 3.20134C14.7816 3.00618 14.4363 2.88865 14.2039 2.82097C14.0878 2.78714 13.9418 2.75363 13.8864 2.7413C13.4794 2.67347 13.1936 2.28755 13.2596 1.87983Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4859 5.3293C13.5997 4.93102 14.0148 4.7004 14.413 4.81419L14.207 5.53534C14.413 4.81419 14.413 4.81419 14.413 4.81419L14.4145 4.81461L14.416 4.81505L14.4194 4.81602L14.4271 4.81834L14.4469 4.8245C14.462 4.82932 14.4808 4.8356 14.5033 4.84357C14.5482 4.85951 14.6075 4.88217 14.6803 4.91337C14.826 4.97581 15.0251 5.07223 15.2696 5.21694C15.7591 5.50662 16.4272 5.9878 17.2122 6.77277C17.9972 7.55775 18.4784 8.22593 18.768 8.7154C18.9128 8.95991 19.0092 9.15897 19.0716 9.30466C19.1028 9.37746 19.1255 9.43682 19.1414 9.48173C19.1494 9.50418 19.1557 9.52301 19.1605 9.53809L19.1666 9.55788L19.169 9.56563L19.1699 9.56896L19.1704 9.5705C19.1704 9.5705 19.1708 9.57194 18.4496 9.77798L19.1708 9.57194C19.2846 9.97021 19.054 10.3853 18.6557 10.4991C18.2608 10.6119 17.8493 10.3862 17.7315 9.99413L17.7278 9.98335C17.7224 9.96832 17.7114 9.93874 17.6929 9.89554C17.6559 9.8092 17.5888 9.66797 17.4772 9.47938C17.2542 9.10264 16.8515 8.53339 16.1516 7.83343C15.4516 7.13348 14.8823 6.73078 14.5056 6.50781C14.317 6.39619 14.1758 6.32909 14.0894 6.29209C14.0462 6.27358 14.0167 6.26254 14.0016 6.25721L13.9909 6.25352C13.5988 6.13564 13.373 5.72419 13.4859 5.3293Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.00745 4.40659C6.68752 2.72653 9.52266 2.85424 10.6925 4.95037L11.3415 6.1133C12.1054 7.48212 11.7799 9.2092 10.6616 10.3412C10.6467 10.3616 10.5677 10.4765 10.5579 10.6773C10.5454 10.9336 10.6364 11.5264 11.5548 12.4448C12.4729 13.363 13.0656 13.4542 13.3221 13.4418C13.5231 13.432 13.6381 13.353 13.6585 13.3381C14.7905 12.2198 16.5176 11.8943 17.8864 12.6582L19.0493 13.3072C21.1454 14.477 21.2731 17.3121 19.5931 18.9922C18.6944 19.8909 17.4995 20.6894 16.0953 20.7426C14.0144 20.8215 10.5591 20.2841 7.13735 16.8623C3.71556 13.4405 3.17818 9.9853 3.25706 7.90437C3.3103 6.50017 4.10879 5.30525 5.00745 4.40659ZM9.38265 5.68136C8.78363 4.60802 7.17394 4.36142 6.06811 5.46725C5.29276 6.2426 4.7887 7.09842 4.75599 7.96119C4.6902 9.69653 5.11864 12.7223 8.19801 15.8017C11.2774 18.881 14.3031 19.3095 16.0385 19.2437C16.9013 19.211 17.7571 18.7069 18.5324 17.9316C19.6382 16.8257 19.3916 15.216 18.3183 14.617L17.1554 13.968C16.432 13.5643 15.4158 13.702 14.7025 14.4153C14.6325 14.4853 14.1864 14.9015 13.395 14.94C12.5847 14.9794 11.604 14.6153 10.4942 13.5055C9.38395 12.3953 9.02003 11.4143 9.0597 10.604C9.09846 9.81245 9.51468 9.36685 9.58432 9.29719C10.2976 8.58387 10.4354 7.5677 10.0317 6.84429L9.38265 5.68136Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'email' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.94358 3.25H14.0564C15.8942 3.24998 17.3498 3.24997 18.489 3.40314C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33856 22.5969 7.51098C22.75 8.65019 22.75 10.1058 22.75 11.9436V12.0564C22.75 13.8942 22.75 15.3498 22.5969 16.489C22.4392 17.6614 22.1071 18.6104 21.3588 19.3588C20.6104 20.1071 19.6614 20.4392 18.489 20.5969C17.3498 20.75 15.8942 20.75 14.0564 20.75H9.94359C8.10583 20.75 6.65019 20.75 5.51098 20.5969C4.33856 20.4392 3.38961 20.1071 2.64124 19.3588C1.89288 18.6104 1.56076 17.6614 1.40314 16.489C1.24997 15.3498 1.24998 13.8942 1.25 12.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40314C6.65019 3.24997 8.10582 3.24998 9.94358 3.25ZM5.71085 4.88976C4.70476 5.02502 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02502 6.70476 2.88976 7.71085C2.75159 8.73851 2.75 10.0932 2.75 12C2.75 13.9068 2.75159 15.2615 2.88976 16.2892C3.02502 17.2952 3.27869 17.8749 3.7019 18.2981C4.12511 18.7213 4.70476 18.975 5.71085 19.1102C6.73851 19.2484 8.09318 19.25 10 19.25H14C15.9068 19.25 17.2615 19.2484 18.2892 19.1102C19.2952 18.975 19.8749 18.7213 20.2981 18.2981C20.7213 17.8749 20.975 17.2952 21.1102 16.2892C21.2484 15.2615 21.25 13.9068 21.25 12C21.25 10.0932 21.2484 8.73851 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02502 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976ZM5.42383 7.51986C5.68901 7.20165 6.16193 7.15866 6.48014 7.42383L8.63903 9.22291C9.57199 10.0004 10.2197 10.5384 10.7666 10.8901C11.2959 11.2306 11.6549 11.3449 12 11.3449C12.3451 11.3449 12.7041 11.2306 13.2334 10.8901C13.7803 10.5384 14.428 10.0004 15.361 9.22291L17.5199 7.42383C17.8381 7.15866 18.311 7.20165 18.5762 7.51986C18.8413 7.83807 18.7983 8.31099 18.4801 8.57617L16.2836 10.4066C15.3973 11.1452 14.6789 11.7439 14.0448 12.1517C13.3843 12.5765 12.7411 12.8449 12 12.8449C11.2589 12.8449 10.6157 12.5765 9.95518 12.1517C9.32112 11.7439 8.60272 11.1452 7.71636 10.4066L5.51986 8.57617C5.20165 8.31099 5.15866 7.83807 5.42383 7.51986Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'contact' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 6.25C7.48122 6.25 6.25 7.48122 6.25 9C6.25 10.5188 7.48122 11.75 9 11.75C10.5188 11.75 11.75 10.5188 11.75 9C11.75 7.48122 10.5188 6.25 9 6.25ZM7.75 9C7.75 8.30965 8.30965 7.75 9 7.75C9.69036 7.75 10.25 8.30965 10.25 9C10.25 9.69036 9.69036 10.25 9 10.25C8.30965 10.25 7.75 9.69036 7.75 9Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 12.25C7.80424 12.25 6.68461 12.4907 5.83616 12.915C5.03258 13.3168 4.25 14.0106 4.25 15L4.24987 15.0625C4.24834 15.5728 4.24576 16.4322 5.06023 17.0218C5.43818 17.2953 5.9369 17.4698 6.55469 17.581C7.1782 17.6932 7.97721 17.75 9 17.75C10.0228 17.75 10.8218 17.6932 11.4453 17.581C12.0631 17.4698 12.5618 17.2953 12.9398 17.0218C13.7542 16.4322 13.7517 15.5728 13.7501 15.0625L13.75 15C13.75 14.0106 12.9674 13.3168 12.1638 12.915C11.3154 12.4907 10.1958 12.25 9 12.25ZM5.75 15C5.75 14.8848 5.86285 14.5787 6.50698 14.2566C7.10625 13.957 7.98662 13.75 9 13.75C10.0134 13.75 10.8937 13.957 11.493 14.2566C12.1371 14.5787 12.25 14.8848 12.25 15C12.25 15.6045 12.2115 15.6972 12.0602 15.8067C11.9382 15.895 11.6869 16.0134 11.1797 16.1047C10.6782 16.1949 9.97721 16.25 9 16.25C8.02279 16.25 7.3218 16.1949 6.82031 16.1047C6.31311 16.0134 6.06182 15.895 5.93977 15.8067C5.78849 15.6972 5.75 15.6045 5.75 15Z"
            fill="currentColor"
          />
          <path
            d="M19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H19Z"
            fill="currentColor"
          />
          <path
            d="M19.75 9C19.75 9.41422 19.4142 9.75 19 9.75H14C13.5858 9.75 13.25 9.41422 13.25 9C13.25 8.58579 13.5858 8.25 14 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9Z"
            fill="currentColor"
          />
          <path
            d="M19 15.75C19.4142 15.75 19.75 15.4142 19.75 15C19.75 14.5858 19.4142 14.25 19 14.25H16C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H19Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.94358 3.25H14.0564C15.8942 3.24998 17.3498 3.24997 18.489 3.40314C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33856 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V12.0564C22.75 13.8942 22.75 15.3498 22.5969 16.489C22.4392 17.6614 22.1071 18.6104 21.3588 19.3588C20.6104 20.1071 19.6614 20.4392 18.489 20.5969C17.3498 20.75 15.8942 20.75 14.0565 20.75H9.94359C8.10585 20.75 6.65018 20.75 5.51098 20.5969C4.33856 20.4392 3.38961 20.1071 2.64124 19.3588C1.89288 18.6104 1.56076 17.6614 1.40314 16.489C1.24997 15.3498 1.24998 13.8942 1.25 12.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33856 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40314C6.65019 3.24997 8.10583 3.24998 9.94358 3.25ZM5.71085 4.88976C4.70476 5.02503 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02503 6.70476 2.88976 7.71085C2.75159 8.73851 2.75 10.0932 2.75 12C2.75 13.9068 2.75159 15.2615 2.88976 16.2892C3.02503 17.2952 3.27869 17.8749 3.7019 18.2981C4.12511 18.7213 4.70476 18.975 5.71085 19.1102C6.73851 19.2484 8.09318 19.25 10 19.25H14C15.9068 19.25 17.2615 19.2484 18.2892 19.1102C19.2952 18.975 19.8749 18.7213 20.2981 18.2981C20.7213 17.8749 20.975 17.2952 21.1102 16.2892C21.2484 15.2615 21.25 13.9068 21.25 12C21.25 10.0932 21.2484 8.73851 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02503 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'edit' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0992 2.39109C15.6207 0.869636 18.0875 0.869636 19.6089 2.39109C21.1304 3.91255 21.1304 6.37932 19.6089 7.90077L12.0149 15.4948C11.5869 15.9228 11.3255 16.1842 11.0342 16.4115C10.691 16.6792 10.3196 16.9087 9.92667 17.096C9.59315 17.2549 9.24244 17.3718 8.66818 17.5632L5.99553 18.4541L5.35386 18.668C4.77951 18.8594 4.14629 18.7099 3.7182 18.2818C3.2901 17.8537 3.14062 17.2205 3.33207 16.6462L4.43683 13.3318C4.62822 12.7576 4.7451 12.4069 4.90405 12.0734C5.09132 11.6804 5.32084 11.309 5.58856 10.9658C5.81578 10.6745 6.07719 10.4131 6.50525 9.98509L14.0992 2.39109ZM5.96092 16.8845L5.11556 16.0391L5.84398 13.8538C6.05606 13.2176 6.14366 12.9589 6.25814 12.7187C6.39854 12.4241 6.57061 12.1457 6.77132 11.8883C6.93497 11.6785 7.12718 11.4845 7.60141 11.0102L13.4924 5.11927C13.7355 5.72927 14.147 6.46549 14.8408 7.15927C15.5345 7.85306 16.2708 8.26447 16.8807 8.50764L10.9898 14.3986C10.5155 14.8728 10.3215 15.065 10.1117 15.2287C9.85436 15.4294 9.57594 15.6015 9.28134 15.7419C9.04113 15.8564 8.78244 15.944 8.14619 16.156L5.96092 16.8845ZM18.076 7.31241C17.9521 7.28522 17.7973 7.24432 17.6213 7.18325C17.1373 7.01532 16.5006 6.69778 15.9014 6.09861C15.3022 5.49944 14.9847 4.86276 14.8168 4.37873C14.7557 4.2027 14.7148 4.04787 14.6876 3.92404L15.1599 3.45175C16.0956 2.51608 17.6126 2.51608 18.5483 3.45175C19.4839 4.38742 19.4839 5.90444 18.5483 6.84011L18.076 7.31241ZM3.25002 22C3.25002 21.5858 3.58581 21.25 4.00002 21.25H20V22.75H4.00002C3.58581 22.75 3.25002 22.4142 3.25002 22Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'arrow-select' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.43057 8.51192C4.70014 8.19743 5.17361 8.161 5.48811 8.43057L12 14.0122L18.5119 8.43057C18.8264 8.16101 19.2999 8.19743 19.5695 8.51192C19.839 8.82642 19.8026 9.29989 19.4881 9.56946L12.4881 15.5695C12.2072 15.8102 11.7928 15.8102 11.5119 15.5695L4.51192 9.56946C4.19743 9.29989 4.161 8.82641 4.43057 8.51192Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'download' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            d="M12.5535 16.5061C12.4114 16.6615 12.2106 16.75 12 16.75C11.7894 16.75 11.5886 16.6615 11.4465 16.5061L7.44648 12.1311C7.16698 11.8254 7.18822 11.351 7.49392 11.0715C7.79963 10.792 8.27402 10.8132 8.55352 11.1189L11.25 14.0682V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V14.0682L15.4465 11.1189C15.726 10.8132 16.2004 10.792 16.5061 11.0715C16.8118 11.351 16.833 11.8254 16.5535 12.1311L12.5535 16.5061Z"
            fill="currentColor"
          />
          <path
            d="M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'eye-view' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'sapp-logo' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="89"
          height="58"
          viewBox="0 0 89 58"
          fill="none"
          className={`${className}`}
        >
          <path
            d="M10.6716 0.719727C17.4268 0.719727 20.8044 4.63775 20.8044 12.4738V14.9537H14.3032V12.0131C14.3032 8.94295 13.1538 7.40841 10.8548 7.4095C8.55592 7.41059 7.40595 8.94513 7.40494 12.0131C7.40494 14.1238 8.10693 16.1479 9.51091 18.0854C10.1807 18.9633 10.9047 19.7924 11.678 20.5669L13.5106 22.3949C13.755 22.6351 13.9688 22.8409 14.152 23.0157C15.1701 24.0166 15.9846 24.8879 16.5955 25.6295C17.4066 26.5649 18.1313 27.582 18.7595 28.6665C20.1625 31.1039 20.8645 33.8266 20.8655 36.8347C20.8655 44.6762 17.4472 48.5969 10.6105 48.5969C3.77381 48.5969 0.355469 44.6762 0.355469 36.8347V32.2899H6.85668V37.2856C6.85668 40.3351 8.04686 41.8598 10.4272 41.8598C12.7872 41.8598 13.9672 40.3351 13.9672 37.2856C13.9672 35.1749 13.2754 33.1601 11.8918 31.2411C11.2181 30.3565 10.4944 29.5169 9.72472 28.7269L7.25222 26.2765C6.2341 25.2767 5.41043 24.4054 4.78124 23.6626C3.98922 22.7293 3.27389 21.7247 2.64318 20.66C1.23706 18.1937 0.507317 15.3542 0.537204 12.4656C0.538222 4.63503 3.91634 0.719727 10.6716 0.719727Z"
            fill="#404041"
          />
          <path
            d="M45.1008 48.0592H38.1735L36.9823 39.5642H28.5599L27.3687 48.0592H21.0508L28.0407 1.24219H38.1124L45.1008 48.0592ZM29.4136 33.2044H36.0675L32.7413 9.53457L29.4136 33.2044Z"
            fill="#404041"
          />
          <path
            d="M56.7561 1.24219C63.5928 1.24219 67.0112 5.10521 67.0112 12.8313V18.9052C67.0112 26.6094 63.5928 30.4616 56.7561 30.4616H53.4895V48.0592H46.6172V1.24219H56.7561ZM53.4895 7.93523V23.8012H56.7546C58.9945 23.8012 60.1144 22.3211 60.1144 19.3609V12.3363C60.1144 9.39571 58.9945 7.92543 56.7546 7.92543L53.4895 7.93523Z"
            fill="#404041"
          />
          <path
            d="M78.5884 1.24219C85.425 1.24219 88.8434 5.10521 88.8434 12.8313V18.9052C88.8434 26.6094 85.425 30.4616 78.5884 30.4616H75.3293V48.0592H68.457V1.24219H78.5884ZM75.3293 7.93523V23.8012H78.5945C80.8343 23.8012 81.9543 22.3211 81.9543 19.3609V12.3363C81.9543 9.39571 80.8343 7.92543 78.5945 7.92543L75.3293 7.93523Z"
            fill="#404041"
          />
          <path
            d="M2.82364 57.0769L2.6587 56.0689H1.47971L1.31478 57.0769H0.433594L1.41099 51.5225H2.81447L3.79187 57.0769H2.82364ZM2.52736 55.3158L2.06921 52.5075L1.61105 55.3158H2.52736Z"
            fill="#404041"
          />
          <path
            d="M6.54146 51.5241C7.02404 51.5241 7.38293 51.6406 7.61812 51.8737C7.74164 52.0075 7.83711 52.1679 7.8982 52.3442C7.95929 52.5205 7.98459 52.7088 7.97242 52.8964V55.7046C7.98459 55.8922 7.95929 56.0804 7.8982 56.2567C7.83711 56.4331 7.74164 56.5935 7.61812 56.7273C7.38293 56.9603 7.02404 57.0769 6.54146 57.0769H5.02344V51.5225L6.54146 51.5241ZM5.98251 56.2829H6.52313C6.65185 56.291 6.7789 56.2486 6.88049 56.1636C6.92985 56.1083 6.96721 56.0419 6.98991 55.9694C7.01261 55.8968 7.02009 55.8198 7.01183 55.7438V52.8571C7.0199 52.7809 7.01233 52.7037 6.98965 52.6309C6.96696 52.5581 6.92971 52.4915 6.88049 52.4357C6.77836 52.352 6.65157 52.3102 6.52313 52.318H5.98251V56.2829Z"
            fill="#404041"
          />
          <path
            d="M11.5398 51.5244H12.421L11.4787 57.0788H10.0477L9.10547 51.5244H10.0737L10.8068 56.0529L11.5398 51.5244Z"
            fill="#404041"
          />
          <path
            d="M15.4806 57.0769L15.3095 56.0689H14.1321L13.9671 57.0769H13.0859L14.0618 51.5225H15.4668L16.4442 57.0769H15.4806ZM15.1843 55.3158L14.7261 52.5075L14.268 55.3158H15.1843Z"
            fill="#404041"
          />
          <path
            d="M18.5347 57.0769H17.6719V51.5225H18.8753L19.8618 54.8453V51.5241H20.7155V57.0785H19.7305L18.5347 53.0565V57.0769Z"
            fill="#404041"
          />
          <path
            d="M24.974 55.7444C24.9855 55.9345 24.9591 56.1252 24.8968 56.3037C24.8344 56.4822 24.7374 56.6446 24.6121 56.7801C24.3708 57.0208 24.0144 57.1411 23.543 57.1411C23.0727 57.1411 22.7153 57.0202 22.474 56.7801C22.3487 56.6446 22.2517 56.4822 22.1893 56.3037C22.1269 56.1252 22.1006 55.9345 22.1121 55.7444V52.8577C22.1004 52.6675 22.1266 52.4768 22.189 52.2983C22.2514 52.1197 22.3486 51.9574 22.474 51.822C22.7153 51.5818 23.0727 51.4609 23.543 51.4609C24.0134 51.4609 24.3708 51.5818 24.6121 51.822C24.7375 51.9574 24.8346 52.1197 24.897 52.2983C24.9594 52.4768 24.9857 52.6675 24.974 52.8577V53.3968H24.0669V52.8022C24.0745 52.725 24.0663 52.6471 24.0428 52.5737C24.0193 52.5004 23.9811 52.4334 23.9309 52.3774C23.825 52.2977 23.6986 52.2549 23.569 52.2549C23.4394 52.2549 23.313 52.2977 23.2071 52.3774C23.1571 52.4335 23.1192 52.5006 23.096 52.5739C23.0728 52.6473 23.0649 52.7252 23.0727 52.8022V55.7999C23.0645 55.8762 23.0723 55.9534 23.0955 56.0261C23.1188 56.0987 23.1569 56.1649 23.2071 56.2197C23.3138 56.2975 23.4399 56.3391 23.569 56.3391C23.6981 56.3391 23.8242 56.2975 23.9309 56.2197C23.9813 56.1649 24.0196 56.0988 24.0431 56.0262C24.0666 55.9536 24.0747 55.8763 24.0669 55.7999V55.0076H24.974V55.7444Z"
            fill="#404041"
          />
          <path
            d="M28.6208 53.8635V54.6574H27.3028V56.2829H28.9598V57.0769H26.3438V51.5225H28.9598V52.3164H27.3028V53.8618L28.6208 53.8635Z"
            fill="#404041"
          />
          <path
            d="M32.1602 51.5244H33.1635L33.8966 54.0549L34.6296 51.5244H35.5459L34.3333 55.2361V57.0772H33.3743V55.2361L32.1602 51.5244Z"
            fill="#404041"
          />
          <path
            d="M37.011 51.822C37.2615 51.5813 37.6219 51.4609 38.0923 51.4609C38.5627 51.4609 38.9236 51.5813 39.1751 51.822C39.3038 51.9554 39.4039 52.1171 39.4685 52.2959C39.5331 52.4747 39.5606 52.6664 39.5492 52.8577V55.7444C39.5605 55.9357 39.5329 56.1273 39.4683 56.3061C39.4037 56.4849 39.3037 56.6466 39.1751 56.7801C38.9246 57.0208 38.5637 57.1411 38.0923 57.1411C37.6209 57.1411 37.2605 57.0208 37.011 56.7801C36.882 56.6469 36.7815 56.4853 36.7167 56.3064C36.6518 56.1276 36.6241 55.9358 36.6354 55.7444V52.8577C36.6238 52.6662 36.6515 52.4744 36.7164 52.2955C36.7813 52.1166 36.8818 51.955 37.011 51.822ZM37.7303 56.2246C37.8363 56.3044 37.9627 56.3472 38.0923 56.3472C38.2218 56.3472 38.3482 56.3044 38.4542 56.2246C38.5044 56.1687 38.5426 56.1017 38.5661 56.0283C38.5895 55.955 38.5978 55.877 38.5901 55.7999V52.8022C38.5978 52.725 38.5895 52.6471 38.5661 52.5737C38.5426 52.5004 38.5044 52.4334 38.4542 52.3774C38.3482 52.2977 38.2218 52.2549 38.0923 52.2549C37.9627 52.2549 37.8363 52.2977 37.7303 52.3774C37.6804 52.4335 37.6425 52.5006 37.6193 52.5739C37.5961 52.6473 37.5881 52.7252 37.596 52.8022V55.7999C37.5881 55.8769 37.5961 55.9548 37.6193 56.0281C37.6425 56.1015 37.6804 56.1686 37.7303 56.2246Z"
            fill="#404041"
          />
          <path
            d="M41.8734 55.8078C41.8652 55.8841 41.873 55.9614 41.8962 56.034C41.9195 56.1066 41.9576 56.1728 42.0078 56.2277C42.1145 56.3054 42.2406 56.347 42.3697 56.347C42.4988 56.347 42.6249 56.3054 42.7316 56.2277C42.782 56.1729 42.8203 56.1068 42.8438 56.0341C42.8673 55.9615 42.8754 55.8842 42.8676 55.8078V51.5244H43.7747V55.7523C43.7862 55.9425 43.7598 56.1331 43.6975 56.3116C43.6351 56.4901 43.5381 56.6525 43.4128 56.788C43.1715 57.0287 42.8151 57.1485 42.3437 57.1474C41.8734 57.1474 41.516 57.0282 41.2747 56.788C41.1494 56.6525 41.0524 56.4901 40.99 56.3116C40.9276 56.1331 40.9013 55.9425 40.9128 55.7523V51.5244H41.8734V55.8078Z"
            fill="#404041"
          />
          <path
            d="M47.1864 56.974C47.1724 56.9355 47.1621 56.8955 47.1559 56.8547C47.1454 56.7943 47.1393 56.7331 47.1376 56.6717C47.1376 56.5982 47.1376 56.5084 47.1376 56.394V55.5216C47.155 55.3249 47.1002 55.1287 46.9849 54.9744C46.919 54.9146 46.8427 54.8694 46.7604 54.8413C46.6781 54.8133 46.5914 54.803 46.5053 54.811H46.1739V57.072H45.2148V51.5176H46.6626C47.162 51.5176 47.5255 51.6238 47.7484 51.8345C47.9714 52.0452 48.0844 52.3671 48.0844 52.7951V53.2313C48.0844 53.8009 47.8752 54.1761 47.4567 54.3569C47.5642 54.3893 47.6642 54.4453 47.7504 54.5212C47.8366 54.5972 47.9072 54.6914 47.9577 54.7979C48.0538 55.0313 48.1002 55.2847 48.0936 55.5396V56.3956C48.093 56.5162 48.0986 56.6368 48.1104 56.7567C48.1242 56.8654 48.1536 56.9712 48.1974 57.0703H47.2216C47.2093 57.0393 47.1971 57.005 47.1864 56.974ZM46.1739 54.022H46.5496C46.6998 54.0317 46.8487 53.9875 46.9726 53.8962C47.0292 53.8368 47.0723 53.7645 47.0987 53.6847C47.1252 53.6049 47.1343 53.5196 47.1253 53.4355V52.8882C47.1383 52.7322 47.0963 52.5767 47.0078 52.452C46.9579 52.4035 46.8992 52.3666 46.8353 52.3435C46.7714 52.3205 46.7038 52.3118 46.6366 52.3181H46.1785L46.1739 54.022Z"
            fill="#404041"
          />
          <path
            d="M54.4232 55.7444C54.4347 55.9345 54.4084 56.1252 54.346 56.3037C54.2836 56.4822 54.1866 56.6446 54.0613 56.7801C53.82 57.0208 53.4636 57.1411 52.9923 57.1411C52.5219 57.1411 52.1645 57.0202 51.9232 56.7801C51.7979 56.6446 51.7009 56.4822 51.6385 56.3037C51.5762 56.1252 51.5498 55.9345 51.5613 55.7444V52.8577C51.5496 52.6675 51.5759 52.4768 51.6383 52.2983C51.7007 52.1197 51.7978 51.9574 51.9232 51.822C52.1645 51.5818 52.5219 51.4609 52.9923 51.4609C53.4626 51.4609 53.82 51.5818 54.0613 51.822C54.1867 51.9574 54.2839 52.1197 54.3463 52.2983C54.4087 52.4768 54.4349 52.6675 54.4232 52.8577V53.3968H53.5161V52.8022C53.5237 52.725 53.5155 52.6471 53.492 52.5737C53.4685 52.5004 53.4304 52.4334 53.3802 52.3774C53.2742 52.2977 53.1478 52.2549 53.0182 52.2549C52.8887 52.2549 52.7623 52.2977 52.6563 52.3774C52.6064 52.4335 52.5685 52.5006 52.5453 52.5739C52.522 52.6473 52.5141 52.7252 52.5219 52.8022V55.7999C52.5137 55.8762 52.5215 55.9534 52.5448 56.0261C52.568 56.0987 52.6061 56.1649 52.6563 56.2197C52.763 56.2975 52.8891 56.3391 53.0182 56.3391C53.1473 56.3391 53.2735 56.2975 53.3802 56.2197C53.4305 56.1649 53.4688 56.0988 53.4924 56.0262C53.5159 55.9536 53.524 55.8763 53.5161 55.7999V55.0076H54.4232V55.7444Z"
            fill="#404041"
          />
          <path
            d="M57.933 57.0769L57.7681 56.0689H56.5891L56.4242 57.0769H55.543L56.5204 51.5225H57.9208L58.8967 57.0769H57.933ZM57.6367 55.3158L57.1786 52.5075L56.7204 55.3158H57.6367Z"
            fill="#404041"
          />
          <path
            d="M62.1005 56.974C62.0864 56.9355 62.0762 56.8955 62.07 56.8547C62.0595 56.7943 62.0534 56.7331 62.0516 56.6717C62.0516 56.5982 62.0516 56.5084 62.0516 56.394V55.5216C62.069 55.3249 62.0143 55.1287 61.8989 54.9744C61.833 54.9146 61.7567 54.8694 61.6744 54.8413C61.5921 54.8133 61.5054 54.803 61.4194 54.811H61.088V57.072H60.1289V51.5176H61.5828C62.0837 51.5176 62.4456 51.6232 62.6686 51.8345C62.8916 52.0458 63.0036 52.366 63.0046 52.7951V53.2313C63.0046 53.8009 62.7954 54.1761 62.3769 54.3569C62.4844 54.3893 62.5844 54.4453 62.6706 54.5212C62.7568 54.5972 62.8274 54.6914 62.8778 54.7979C62.974 55.0313 63.0204 55.2847 63.0138 55.5396V56.3956C63.0132 56.5162 63.0188 56.6368 63.0306 56.7567C63.0444 56.8654 63.0737 56.9712 63.1176 57.0703H62.1417C62.1234 57.0393 62.1112 57.005 62.1005 56.974ZM61.088 54.022H61.4637C61.6138 54.0317 61.7628 53.9875 61.8867 53.8962C61.9432 53.8368 61.9863 53.7645 62.0128 53.6847C62.0393 53.6049 62.0484 53.5196 62.0394 53.4355V52.8882C62.0523 52.7322 62.0104 52.5767 61.9218 52.452C61.8719 52.4035 61.8132 52.3666 61.7494 52.3435C61.6855 52.3205 61.6179 52.3118 61.5507 52.3181H61.0926L61.088 54.022Z"
            fill="#404041"
          />
          <path
            d="M66.6989 53.8635V54.6574H65.3825V56.2829H67.0395V57.0769H64.4219V51.5225H67.0395V52.3164H65.3825V53.8618L66.6989 53.8635Z"
            fill="#404041"
          />
          <path
            d="M70.695 53.8635V54.6574H69.374V56.2829H71.031V57.0769H68.418V51.5225H71.0356V52.3164H69.374V53.8618L70.695 53.8635Z"
            fill="#404041"
          />
          <path
            d="M74.3857 56.974C74.3723 56.9352 74.3621 56.8953 74.3551 56.8547C74.3447 56.7943 74.3385 56.7331 74.3368 56.6717C74.3368 56.5982 74.3368 56.5084 74.3368 56.394V55.5216C74.3542 55.3249 74.2994 55.1287 74.1841 54.9744C74.1182 54.9146 74.0419 54.8694 73.9596 54.8413C73.8773 54.8133 73.7906 54.803 73.7045 54.811H73.3731V57.072H72.4141V51.5176H73.8618C74.3628 51.5176 74.7247 51.6232 74.9477 51.8345C75.1706 52.0458 75.2826 52.366 75.2836 52.7951V53.2313C75.2836 53.8009 75.0744 54.1761 74.656 54.3569C74.7634 54.3893 74.8634 54.4453 74.9496 54.5212C75.0359 54.5972 75.1064 54.6914 75.1569 54.7979C75.253 55.0313 75.2995 55.2847 75.2928 55.5396V56.3956C75.2922 56.5162 75.2978 56.6368 75.3096 56.7567C75.3234 56.8654 75.3528 56.9712 75.3967 57.0703H74.4208C74.4131 57.0393 74.3963 57.005 74.3857 56.974ZM73.3731 54.022H73.7488C73.899 54.0317 74.0479 53.9875 74.1718 53.8962C74.2284 53.8368 74.2715 53.7645 74.298 53.6847C74.3244 53.6049 74.3335 53.5196 74.3246 53.4355V52.8882C74.3375 52.7322 74.2956 52.5767 74.207 52.452C74.1571 52.4035 74.0984 52.3666 74.0345 52.3435C73.9707 52.3205 73.903 52.3118 73.8359 52.3181H73.3777L73.3731 54.022Z"
            fill="#404041"
          />
        </svg>
      )}
      {type === 'share' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 2.25C14.7051 2.25 13.25 3.70507 13.25 5.5C13.25 5.69591 13.2673 5.88776 13.3006 6.07412L8.56991 9.38558C8.54587 9.4024 8.52312 9.42038 8.50168 9.43939C7.94993 9.00747 7.25503 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.25503 15.25 7.94993 14.9925 8.50168 14.5606C8.52312 14.5796 8.54587 14.5976 8.56991 14.6144L13.3006 17.9259C13.2673 18.1122 13.25 18.3041 13.25 18.5C13.25 20.2949 14.7051 21.75 16.5 21.75C18.2949 21.75 19.75 20.2949 19.75 18.5C19.75 16.7051 18.2949 15.25 16.5 15.25C15.4472 15.25 14.5113 15.7506 13.9174 16.5267L9.43806 13.3911C9.63809 12.9694 9.75 12.4978 9.75 12C9.75 11.5022 9.63809 11.0306 9.43806 10.6089L13.9174 7.4733C14.5113 8.24942 15.4472 8.75 16.5 8.75C18.2949 8.75 19.75 7.29493 19.75 5.5C19.75 3.70507 18.2949 2.25 16.5 2.25ZM14.75 5.5C14.75 4.5335 15.5335 3.75 16.5 3.75C17.4665 3.75 18.25 4.5335 18.25 5.5C18.25 6.4665 17.4665 7.25 16.5 7.25C15.5335 7.25 14.75 6.4665 14.75 5.5ZM6.5 10.25C5.5335 10.25 4.75 11.0335 4.75 12C4.75 12.9665 5.5335 13.75 6.5 13.75C7.4665 13.75 8.25 12.9665 8.25 12C8.25 11.0335 7.4665 10.25 6.5 10.25ZM16.5 16.75C15.5335 16.75 14.75 17.5335 14.75 18.5C14.75 19.4665 15.5335 20.25 16.5 20.25C17.4665 20.25 18.25 19.4665 18.25 18.5C18.25 17.5335 17.4665 16.75 16.5 16.75Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'shield-warning' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167V11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914V10.4167ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'delete' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3094 2.25002H13.6908C13.9072 2.24988 14.0957 2.24976 14.2737 2.27819C14.977 2.39049 15.5856 2.82915 15.9146 3.46084C15.9978 3.62073 16.0573 3.79961 16.1256 4.00494L16.2373 4.33984C16.2562 4.39653 16.2616 4.41258 16.2661 4.42522C16.4413 4.90933 16.8953 5.23659 17.4099 5.24964C17.4235 5.24998 17.44 5.25004 17.5001 5.25004H20.5001C20.9143 5.25004 21.2501 5.58582 21.2501 6.00004C21.2501 6.41425 20.9143 6.75004 20.5001 6.75004H3.5C3.08579 6.75004 2.75 6.41425 2.75 6.00004C2.75 5.58582 3.08579 5.25004 3.5 5.25004H6.50008C6.56013 5.25004 6.5767 5.24998 6.59023 5.24964C7.10488 5.23659 7.55891 4.90936 7.73402 4.42524C7.73863 4.41251 7.74392 4.39681 7.76291 4.33984L7.87452 4.00496C7.94281 3.79964 8.00233 3.62073 8.08559 3.46084C8.41453 2.82915 9.02313 2.39049 9.72643 2.27819C9.90445 2.24976 10.093 2.24988 10.3094 2.25002ZM9.00815 5.25004C9.05966 5.14902 9.10531 5.04404 9.14458 4.93548C9.1565 4.90251 9.1682 4.86742 9.18322 4.82234L9.28302 4.52292C9.37419 4.24941 9.39519 4.19363 9.41601 4.15364C9.52566 3.94307 9.72853 3.79686 9.96296 3.75942C10.0075 3.75231 10.067 3.75004 10.3553 3.75004H13.6448C13.9331 3.75004 13.9927 3.75231 14.0372 3.75942C14.2716 3.79686 14.4745 3.94307 14.5842 4.15364C14.605 4.19363 14.626 4.2494 14.7171 4.52292L14.8169 4.82216L14.8556 4.9355C14.8949 5.04405 14.9405 5.14902 14.992 5.25004H9.00815Z"
            fill="currentColor"
          />
          <path
            d="M5.91509 8.45015C5.88754 8.03685 5.53016 7.72415 5.11686 7.7517C4.70357 7.77925 4.39086 8.13663 4.41841 8.54993L4.88186 15.5017C4.96736 16.7844 5.03642 17.8205 5.19839 18.6336C5.36679 19.4789 5.65321 20.185 6.2448 20.7385C6.8364 21.2919 7.55995 21.5308 8.4146 21.6425C9.23662 21.7501 10.275 21.7501 11.5606 21.75H12.4395C13.7251 21.7501 14.7635 21.7501 15.5856 21.6425C16.4402 21.5308 17.1638 21.2919 17.7554 20.7385C18.347 20.185 18.6334 19.4789 18.8018 18.6336C18.9638 17.8206 19.0328 16.7844 19.1183 15.5017L19.5818 8.54993C19.6093 8.13663 19.2966 7.77925 18.8833 7.7517C18.47 7.72415 18.1126 8.03685 18.0851 8.45015L17.6251 15.3493C17.5353 16.6971 17.4713 17.6349 17.3307 18.3406C17.1943 19.025 17.004 19.3873 16.7306 19.6431C16.4572 19.8989 16.083 20.0647 15.391 20.1552C14.6776 20.2485 13.7376 20.25 12.3868 20.25H11.6134C10.2626 20.25 9.32255 20.2485 8.60915 20.1552C7.91715 20.0647 7.54299 19.8989 7.26958 19.6431C6.99617 19.3873 6.80583 19.025 6.66948 18.3406C6.52892 17.6349 6.46489 16.6971 6.37503 15.3493L5.91509 8.45015Z"
            fill="currentColor"
          />
          <path
            d="M9.42546 10.2538C9.83762 10.2125 10.2052 10.5133 10.2464 10.9254L10.7464 15.9254C10.7876 16.3376 10.4869 16.7051 10.0747 16.7463C9.66256 16.7875 9.29503 16.4868 9.25381 16.0747L8.75381 11.0747C8.7126 10.6625 9.01331 10.295 9.42546 10.2538Z"
            fill="currentColor"
          />
          <path
            d="M14.5747 10.2538C14.9869 10.295 15.2876 10.6625 15.2464 11.0747L14.7464 16.0747C14.7052 16.4868 14.3376 16.7875 13.9255 16.7463C13.5133 16.7051 13.2126 16.3376 13.2538 15.9254L13.7538 10.9254C13.795 10.5133 14.1626 10.2125 14.5747 10.2538Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'mail-box' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="88"
          height="88"
          viewBox="0 0 88 88"
          fill="none"
          className={`${className}`}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.4585 11.917H51.5389C58.2774 11.9169 63.6147 11.9169 67.7918 12.4785C72.0907 13.0565 75.5701 14.2742 78.3141 17.0182C81.0581 19.7622 82.2759 23.2417 82.8539 27.5406C83.4155 31.7177 83.4154 37.055 83.4154 43.7935V44.2072C83.4154 50.9456 83.4155 56.283 82.8539 60.4601C82.2759 64.759 81.0581 68.2384 78.3141 70.9824C75.5701 73.7264 72.0907 74.9442 67.7918 75.5222C63.6147 76.0838 58.2773 76.0837 51.5389 76.0837H36.4585C29.7201 76.0837 24.3827 76.0838 20.2056 75.5222C15.9067 74.9442 12.4273 73.7264 9.68326 70.9824C6.93926 68.2384 5.7215 64.759 5.14353 60.4601C4.58193 56.283 4.58197 50.9456 4.58203 44.2072V43.7935C4.58197 37.055 4.58193 31.7177 5.14353 27.5406C5.7215 23.2417 6.93926 19.7622 9.68326 17.0182C12.4273 14.2742 15.9067 13.0565 20.2056 12.4785C24.3827 11.9169 29.7201 11.9169 36.4585 11.917ZM20.9385 17.9294C17.2495 18.4254 15.1241 19.3555 13.5723 20.9073C12.0206 22.4591 11.0905 24.5844 10.5945 28.2734C10.0879 32.0415 10.082 37.0087 10.082 44.0003C10.082 50.992 10.0879 55.9591 10.5945 59.7272C11.0905 63.4162 12.0206 65.5416 13.5723 67.0933C15.1241 68.6451 17.2495 69.5752 20.9385 70.0712C24.7066 70.5778 29.6737 70.5837 36.6654 70.5837H51.332C58.3237 70.5837 63.2908 70.5778 67.0589 70.0712C70.7479 69.5752 72.8733 68.6451 74.425 67.0933C75.9768 65.5416 76.9069 63.4162 77.4029 59.7272C77.9095 55.9591 77.9154 50.992 77.9154 44.0003C77.9154 37.0087 77.9095 32.0415 77.4029 28.2734C76.9069 24.5844 75.9768 22.4591 74.425 20.9073C72.8733 19.3555 70.7479 18.4254 67.0589 17.9294C63.2908 17.4228 58.3237 17.417 51.332 17.417H36.6654C29.6737 17.417 24.7066 17.4228 20.9385 17.9294ZM19.8861 27.5732C20.8584 26.4064 22.5924 26.2488 23.7592 27.2211L31.6752 33.8177C35.096 36.6684 37.471 38.6412 39.4762 39.9308C41.4172 41.1792 42.7334 41.5982 43.9987 41.5982C45.264 41.5982 46.5802 41.1792 48.5212 39.9308C50.5264 38.6412 52.9014 36.6684 56.3223 33.8177L64.2382 27.2211C65.405 26.2488 67.139 26.4064 68.1113 27.5732C69.0836 28.7399 68.926 30.474 67.7592 31.4463L59.7054 38.1578C56.4554 40.8662 53.8213 43.0614 51.4964 44.5566C49.0746 46.1143 46.716 47.0982 43.9987 47.0982C41.2814 47.0982 38.9228 46.1143 36.501 44.5566C34.1761 43.0614 31.542 40.8662 28.292 38.1578L20.2382 31.4463C19.0714 30.474 18.9138 28.7399 19.8861 27.5732Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'fullscreen-exit' && (
        <svg
          width="23"
          height="23"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {' '}
            <polygon
              fill="var(--ci-primary-color, #fff)"
              points="204 181.372 38.628 16 16 16 16 38.628 181.372 204 44 204 44 236 236 236 236 44 204 44 204 181.372"
              className="ci-primary"
            ></polygon>{' '}
            <polygon
              fill="var(--ci-primary-color, #fff)"
              points="326.628 304 464 304 464 272 272 272 272 464 304 464 304 326.628 473.372 496 496 496 496 473.372 326.628 304"
              className="ci-primary"
            ></polygon>{' '}
          </g>
        </svg>
      )}
      {type === 'loading' && (
        <svg
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          width="24"
          height="24"
          style={{
            shapeRendering: 'auto',
            display: 'block',
            background: 'transparent',
          }}
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g>
            <g transform="rotate(0 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.9166666666666666s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(30 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.8333333333333334s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(60 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.75s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(90 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.6666666666666666s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(120 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.5833333333333334s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(150 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.5s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(180 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.4166666666666667s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(210 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.3333333333333333s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(240 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.25s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(270 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.16666666666666666s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(300 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="-0.08333333333333333s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g transform="rotate(330 50 50)">
              <rect
                fill="#f80903"
                height="12"
                width="6"
                ry="6"
                rx="3"
                y="24"
                x="47"
              >
                <animate
                  repeatCount="indefinite"
                  begin="0s"
                  dur="1s"
                  keyTimes="0;1"
                  values="1;0"
                  attributeName="opacity"
                ></animate>
              </rect>
            </g>
            <g></g>
          </g>
        </svg>
      )}
    </>
  )
}
export const TimeOutIcon = () => {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.8321 5.87589C30.637 7.16381 30.2455 8.86043 28.9576 9.66538L14.2908 18.832C13.0029 19.637 11.3063 19.2455 10.5013 17.9575C9.69638 16.6696 10.0879 14.973 11.3758 14.168L26.0426 5.00138C27.3305 4.19643 29.0271 4.58796 29.8321 5.87589ZM58.168 5.87588C58.973 4.58795 60.6696 4.19643 61.9575 5.00138L76.6242 14.168C77.9121 14.973 78.3036 16.6696 77.4987 17.9575C76.6937 19.2455 74.9971 19.637 73.7092 18.832L59.0425 9.66537C57.7546 8.86042 57.3631 7.1638 58.168 5.87588ZM44 17.4167C27.2934 17.4167 13.75 30.9601 13.75 47.6667C13.75 64.3733 27.2934 77.9167 44 77.9167C60.7066 77.9167 74.25 64.3733 74.25 47.6667C74.25 30.9601 60.7066 17.4167 44 17.4167ZM8.25 47.6667C8.25 27.9225 24.2558 11.9167 44 11.9167C63.7442 11.9167 79.75 27.9225 79.75 47.6667C79.75 67.4109 63.7442 83.4167 44 83.4167C24.2558 83.4167 8.25 67.4109 8.25 47.6667ZM53.7227 37.944C54.7967 39.0179 54.7967 40.7591 53.7227 41.8331L47.889 47.6668L53.7227 53.5004C54.7966 54.5743 54.7966 56.3156 53.7227 57.3895C52.6487 58.4634 50.9075 58.4634 49.8336 57.3895L43.9999 51.5559L38.1664 57.3894C37.0924 58.4634 35.3512 58.4634 34.2773 57.3894C33.2033 56.3155 33.2033 54.5743 34.2773 53.5003L40.1108 47.6668L34.2772 41.8331C33.2033 40.7592 33.2033 39.018 34.2772 37.9441C35.3512 36.8701 37.0924 36.8701 38.1663 37.9441L43.9999 43.7777L49.8336 37.944C50.9076 36.87 52.6488 36.87 53.7227 37.944Z"
        fill="#FFB700"
      />
    </svg>
  )
}

export const VerifiedIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="verified 1" clipPath="url(#clip0_12314_6902)">
        <g id="Group">
          <path
            id="Vector"
            d="M7 13.5625C10.6244 13.5625 13.5625 10.6244 13.5625 7C13.5625 3.37563 10.6244 0.4375 7 0.4375C3.37563 0.4375 0.4375 3.37563 0.4375 7C0.4375 10.6244 3.37563 13.5625 7 13.5625Z"
            fill="#FFB800"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.13154 7.30932C2.83896 7.01674 2.83896 6.54235 3.13154 6.24977C3.42412 5.95719 3.89851 5.95719 4.19109 6.24977L6.04718 8.10587L9.81096 4.30454C10.1019 4.01196 10.575 4.01065 10.8676 4.30161C11.1602 4.59258 11.1615 5.06565 10.8705 5.35823C9.43994 6.8031 8.01549 8.25899 6.57811 9.69637C6.28553 9.98895 5.81115 9.98895 5.51857 9.69637L3.13154 7.30932Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12314_6902">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ArrowDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.43057 8.51192C4.70014 8.19743 5.17361 8.161 5.48811 8.43057L12 14.0122L18.5119 8.43057C18.8264 8.16101 19.2999 8.19743 19.5695 8.51192C19.839 8.82642 19.8026 9.29989 19.4881 9.56946L12.4881 15.5695C12.2072 15.8102 11.7928 15.8102 11.5119 15.5695L4.51192 9.56946C4.19743 9.29989 4.161 8.82641 4.43057 8.51192Z"
      fill="currentColor"
    />
  </svg>
)

export const CourseSearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.58464 2.29169C5.55756 2.29169 2.29297 5.55628 2.29297 9.58335C2.29297 13.6104 5.55756 16.875 9.58464 16.875C13.6117 16.875 16.8763 13.6104 16.8763 9.58335C16.8763 5.55628 13.6117 2.29169 9.58464 2.29169ZM1.04297 9.58335C1.04297 4.86592 4.8672 1.04169 9.58464 1.04169C14.3021 1.04169 18.1263 4.86592 18.1263 9.58335C18.1263 11.7171 17.3439 13.6681 16.0504 15.1652L18.7766 17.8914C19.0207 18.1355 19.0207 18.5312 18.7766 18.7753C18.5325 19.0194 18.1368 19.0194 17.8927 18.7753L15.1665 16.0491C13.6694 17.3426 11.7184 18.125 9.58464 18.125C4.8672 18.125 1.04297 14.3008 1.04297 9.58335Z"
      fill="#404041"
    />
  </svg>
)

export const HandShake = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" fill="none">
    <path
      fill="#FFB700"
      fillRule="evenodd"
      d="M69.323 14.381c-3.718-3.797-9.02-5.197-14.21-3.72a2.75 2.75 0 0 1-1.505-5.29c7.106-2.022 14.5-.092 19.645 5.162a2.75 2.75 0 1 1-3.93 3.848Zm-28.29-2.25c-.786-1.345-3.073-2.162-5.397-.834-2.315 1.323-2.722 3.655-1.95 4.978l9.26 15.88a2.75 2.75 0 1 1-4.75 2.771l-9.262-15.88c0-.001 0 0 0 0l-3.087-5.294c-.784-1.346-3.072-2.162-5.395-.835-2.315 1.324-2.722 3.656-1.951 4.978l13.891 23.821a2.75 2.75 0 1 1-4.751 2.771L21.467 33.9c-.785-1.346-3.072-2.162-5.396-.834-2.315 1.322-2.722 3.655-1.95 4.977l13.89 23.821c5.9 10.117 20.458 13.4 32.804 6.344 12.337-7.05 16.722-21.136 10.836-31.23l-9.26-15.88c-.785-1.346-3.073-2.162-5.396-.834-2.315 1.323-2.722 3.655-1.95 4.978l6.173 10.587a2.75 2.75 0 0 1-1.011 3.773c-5.656 3.232-7.39 9.482-4.913 13.728a2.75 2.75 0 0 1-4.751 2.77c-3.884-6.66-1.44-14.898 4.632-19.715L41.032 12.13Zm10.002 6.237L45.783 9.36c-2.625-4.501-8.518-5.33-12.876-2.84a10.458 10.458 0 0 0-3.346 3.041c-2.934-3.23-7.986-3.621-11.838-1.42-4.367 2.496-6.612 8-3.973 12.524l3.674 6.301a10.543 10.543 0 0 0-4.082 1.323c-4.366 2.496-6.611 8-3.973 12.524l13.891 23.82c7.74 13.273 25.904 16.568 40.284 8.35 14.388-8.224 20.612-25.48 12.859-38.776l-9.261-15.88c-2.625-4.502-8.518-5.33-12.876-2.84a10.463 10.463 0 0 0-3.23 2.88Zm-34.85 47.116a2.75 2.75 0 0 1 3.761.99c3.032 5.2 7.667 9.13 13.383 11.682a2.75 2.75 0 1 1-2.242 5.022c-6.642-2.964-12.214-7.627-15.892-13.933a2.75 2.75 0 0 1 .99-3.761Z"
      clipRule="evenodd"
    />
  </svg>
)
export const CloseIconV2 = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18 18L6 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 18L18 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const NoDataIconV2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="203"
    height="203"
    viewBox="0 0 203 203"
    fill="none"
  >
    <path
      d="M107.681 165.699C143.206 165.699 172.007 136.898 172.007 101.246C172.007 65.5946 143.206 36.7939 107.681 36.7939C72.1561 36.7939 43.3555 65.5946 43.3555 101.246C43.3555 136.898 72.1561 165.699 107.681 165.699Z"
      fill="#F1F3FA"
    />
    <g filter="url(#filter0_d_3282_84073)">
      <path
        d="M167.31 75.4912H57.3098C54.8992 75.4912 52.9961 73.5881 52.9961 71.1774V46.4368C52.9961 44.0262 54.8992 42.123 57.3098 42.123H167.184C169.594 42.123 171.497 44.0262 171.497 46.4368V71.1774C171.624 73.5881 169.594 75.4912 167.31 75.4912Z"
        fill="white"
      />
    </g>
    <path
      d="M79.6406 58.7441C79.6406 61.5354 78.3719 64.0729 76.4687 65.8491C74.8194 67.3716 72.5356 68.2598 70.125 68.2598C67.7144 68.2598 65.4306 67.3716 63.7813 65.8491C61.7513 64.0729 60.6094 61.5354 60.6094 58.7441C60.6094 53.5423 64.9231 49.2285 70.125 49.2285C75.3269 49.2285 79.6406 53.5423 79.6406 58.7441Z"
      fill="#D5DAE5"
    />
    <path
      d="M110.852 55.9519H86.4916C85.8572 55.9519 85.4766 55.4444 85.4766 54.9369V51.765C85.4766 51.1306 85.9841 50.75 86.4916 50.75H110.852C111.486 50.75 111.867 51.2575 111.867 51.765V54.9369C111.867 55.5713 111.486 55.9519 110.852 55.9519Z"
      fill="#D5DAE5"
    />
    <path
      d="M139.779 66.7361H86.4916C85.8572 66.7361 85.4766 66.2286 85.4766 65.7211V62.5492C85.4766 61.9148 85.9841 61.5342 86.4916 61.5342H139.779C140.413 61.5342 140.794 62.0417 140.794 62.5492V65.7211C140.794 66.3554 140.287 66.7361 139.779 66.7361Z"
      fill="#D5DAE5"
    />
    <g filter="url(#filter1_d_3282_84073)">
      <path
        d="M167.31 158.721H57.3098C54.8992 158.721 52.9961 156.818 52.9961 154.407V129.666C52.9961 127.256 54.8992 125.353 57.3098 125.353H167.184C169.594 125.353 171.497 127.256 171.497 129.666V154.407C171.624 156.818 169.594 158.721 167.31 158.721Z"
        fill="white"
      />
    </g>
    <path
      d="M79.6406 141.974C79.6406 144.765 78.3719 147.302 76.4687 149.079C74.8194 150.601 72.5356 151.489 70.125 151.489C67.7144 151.489 65.4306 150.601 63.7813 149.079C61.7513 147.302 60.6094 144.765 60.6094 141.974C60.6094 136.772 64.9231 132.458 70.125 132.458C75.3269 132.458 79.6406 136.772 79.6406 141.974Z"
      fill="#D5DAE5"
    />
    <path
      d="M110.852 139.308H86.4916C85.8572 139.308 85.4766 138.801 85.4766 138.293V135.121C85.4766 134.487 85.9841 134.106 86.4916 134.106H110.852C111.486 134.106 111.867 134.614 111.867 135.121V138.293C111.867 138.801 111.486 139.308 110.852 139.308Z"
      fill="#D5DAE5"
    />
    <path
      d="M139.779 150.093H86.4916C85.8572 150.093 85.4766 149.585 85.4766 149.078V145.906C85.4766 145.271 85.9841 144.891 86.4916 144.891H139.779C140.413 144.891 140.794 145.398 140.794 145.906V149.078C140.794 149.585 140.287 150.093 139.779 150.093Z"
      fill="#D5DAE5"
    />
    <g filter="url(#filter2_d_3282_84073)">
      <path
        d="M148.66 117.105H38.7864C36.3758 117.105 34.4727 115.202 34.4727 112.792V88.0511C34.4727 85.6404 36.3758 83.7373 38.7864 83.7373H148.66C151.071 83.7373 152.974 85.6404 152.974 88.0511V112.792C153.101 115.202 151.071 117.105 148.66 117.105Z"
        fill="white"
      />
    </g>
    <path
      d="M92.3281 97.5671H67.9681C67.3337 97.5671 66.9531 97.0596 66.9531 96.5521V93.3802C66.9531 92.7459 67.4606 92.3652 67.9681 92.3652H92.3281C92.9625 92.3652 93.3431 92.8727 93.3431 93.3802V96.5521C93.3431 97.1865 92.9625 97.5671 92.3281 97.5671Z"
      fill="#D5DAE5"
    />
    <path
      d="M121.256 108.478H67.9681C67.3337 108.478 66.9531 107.971 66.9531 107.463V104.291C66.9531 103.657 67.4606 103.276 67.9681 103.276H121.129C121.763 103.276 122.144 103.784 122.144 104.291V107.463C122.271 107.971 121.763 108.478 121.256 108.478Z"
      fill="#D5DAE5"
    />
    <path
      d="M61.2441 100.358C61.2441 103.023 60.1022 105.433 58.3259 107.21C58.1991 107.337 58.1991 107.337 58.0722 107.463C56.4228 108.986 54.1391 109.874 51.7284 109.874C49.3178 109.874 47.1609 108.986 45.5116 107.59C45.5116 107.59 45.5116 107.59 45.3847 107.59C43.3547 105.814 42.0859 103.277 42.0859 100.358C42.0859 95.1565 46.3997 90.8428 51.6016 90.8428C56.9303 90.8428 61.2441 95.1565 61.2441 100.358Z"
      fill="#D5DAE5"
    />
    <defs>
      <filter
        id="filter0_d_3282_84073"
        x="43.9961"
        y="38.123"
        width="136.508"
        height="51.3682"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="4.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3282_84073"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3282_84073"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3282_84073"
        x="43.9961"
        y="121.353"
        width="136.508"
        height="51.3682"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="4.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3282_84073"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3282_84073"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_3282_84073"
        x="25.4727"
        y="79.7373"
        width="136.508"
        height="51.3682"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="4.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3282_84073"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3282_84073"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export const NoCoursesAvailableIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="157"
    height="138"
    viewBox="0 0 157 138"
    fill="none"
  >
    <g filter="url(#filter0_d_12619_123960)">
      <rect
        x="12.2539"
        y="9.19043"
        width="131.723"
        height="112.731"
        rx="12.0098"
        fill="white"
      />
      <circle cx="25.7319" cy="20.8306" r="2.45067" fill="#E5E7EB" />
      <circle cx="33.6968" cy="20.8306" r="2.45067" fill="#E5E7EB" />
      <circle cx="41.6616" cy="20.8306" r="2.45067" fill="#E5E7EB" />
      <rect
        x="15.9297"
        y="28.7959"
        width="124.984"
        height="6.12667"
        rx="3.06334"
        fill="#F2F3F5"
      />
      <rect
        x="66.168"
        y="47.7881"
        width="28.5233"
        height="27.0221"
        rx="4.50368"
        fill="#F7F7F7"
      />
      <rect
        x="23.2812"
        y="79.0342"
        width="34.3094"
        height="30.6334"
        rx="4.50368"
        fill="#F7F7F7"
      />
      <rect
        x="23.2812"
        y="47.7881"
        width="34.3094"
        height="13.4787"
        rx="4.50368"
        fill="#F7F7F7"
      />
      <rect
        x="66.168"
        y="96.1895"
        width="20.2666"
        height="13.511"
        rx="4.50368"
        fill="#F7F7F7"
      />
      <rect
        x="99.1016"
        y="81.4854"
        width="32.4714"
        height="28.1827"
        rx="4.50368"
        fill="#F7F7F7"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_12619_123960"
        x="0.000559807"
        y="0.000419855"
        width="156.229"
        height="137.237"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.06334" />
        <feGaussianBlur stdDeviation="6.12667" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12619_123960"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12619_123960"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export const StarCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.8613 9.36335L10.7302 9.59849C10.5862 9.85677 10.5142 9.98591 10.402 10.0711C10.2897 10.1563 10.1499 10.188 9.87035 10.2512L9.61581 10.3088C8.63195 10.5314 8.14001 10.6427 8.02297 11.0191C7.90593 11.3955 8.2413 11.7876 8.91204 12.572L9.08557 12.7749C9.27617 12.9978 9.37147 13.1092 9.41435 13.2471C9.45722 13.385 9.44281 13.5336 9.41399 13.831L9.38776 14.1018C9.28635 15.1482 9.23565 15.6715 9.54206 15.9041C9.84847 16.1367 10.3091 15.9246 11.2303 15.5005L11.4686 15.3907C11.7304 15.2702 11.8613 15.2099 12 15.2099C12.1387 15.2099 12.2696 15.2702 12.5314 15.3907L12.7697 15.5005C13.6909 15.9246 14.1515 16.1367 14.4579 15.9041C14.7644 15.6715 14.7136 15.1482 14.6122 14.1018L14.586 13.831C14.5572 13.5336 14.5428 13.385 14.5857 13.2471C14.6285 13.1092 14.7238 12.9978 14.9144 12.7749L15.088 12.572C15.7587 11.7876 16.0941 11.3955 15.977 11.0191C15.86 10.6427 15.3681 10.5314 14.3842 10.3088L14.1296 10.2512C13.8501 10.188 13.7103 10.1563 13.598 10.0711C13.4858 9.98592 13.4138 9.85678 13.2698 9.5985L13.1387 9.36335C12.6321 8.45445 12.3787 8 12 8C11.6213 8 11.3679 8.45446 10.8613 9.36335Z"
      fill="#1C274C"
    />
  </svg>
)

export const GraduationCapIcon = ({
  className,
  fill = '#1C274C',
}: {
  className?: string
  fill?: string
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.46435 2.82057C11.0871 2.05981 12.9128 2.05981 14.5356 2.82057L21.2268 5.95756C22.2791 6.4509 22.75 7.52222 22.75 8.50002C22.75 9.47782 22.2791 10.5491 21.2268 11.0425L19.75 11.7348V16.6254C19.75 17.8785 19.1217 19.0883 17.978 19.7217C17.2263 20.138 16.2384 20.6391 15.1988 21.038C14.1715 21.4321 13.0339 21.75 12 21.75C10.9661 21.75 9.82851 21.4321 8.80116 21.038C7.76158 20.6391 6.77371 20.138 6.02198 19.7217C4.87826 19.0883 4.25 17.8785 4.25 16.6254V11.7348L2.77323 11.0424L2.75 11.0314V14C2.75 14.4142 2.41421 14.75 2 14.75C1.58579 14.75 1.25 14.4142 1.25 14V8.5C1.25 7.5222 1.72095 6.45085 2.77324 5.95752L9.46435 2.82057ZM5.75 12.438V16.6254C5.75 17.3884 6.12875 18.0661 6.74868 18.4095C7.46533 18.8063 8.38678 19.2724 9.33844 19.6375C10.3023 20.0073 11.2379 20.25 12 20.25C12.7621 20.25 13.6977 20.0073 14.6616 19.6375C15.6132 19.2724 16.5347 18.8063 17.2513 18.4095C17.8713 18.0661 18.25 17.3884 18.25 16.6254V12.4381L14.5357 14.1794C12.9129 14.9402 11.0872 14.9402 9.46444 14.1794L5.75 12.438ZM3.40996 9.68429C3.00679 9.49527 2.75 9.04438 2.75 8.49998C2.75 7.95557 3.00679 7.50469 3.40997 7.31567L10.1011 4.17872C11.3204 3.60709 12.6795 3.60709 13.8988 4.17873L20.59 7.31571C20.9932 7.50473 21.25 7.95562 21.25 8.50002C21.25 9.04443 20.9932 9.49531 20.59 9.68433L13.8989 12.8213C12.6796 13.3929 11.3205 13.3929 10.1012 12.8213L3.40996 9.68429Z"
      fill={fill}
    />
  </svg>
)

export const CourseTimeIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.84501 1.6026C9.06454 1.95386 8.95776 2.41657 8.60651 2.6361L4.60648 5.1361C4.25523 5.35563 3.79252 5.24885 3.57298 4.8976C3.35345 4.54634 3.46023 4.08363 3.81149 3.8641L7.81151 1.3641C8.16276 1.14457 8.62548 1.25135 8.84501 1.6026ZM16.573 1.6026C16.7925 1.25135 17.2552 1.14457 17.6065 1.3641L21.6065 3.8641C21.9577 4.08363 22.0645 4.54635 21.845 4.8976C21.6255 5.24885 21.1627 5.35563 20.8115 5.1361L16.8115 2.6361C16.4602 2.41657 16.3535 1.95385 16.573 1.6026ZM12.709 4.7501C8.15264 4.7501 4.45898 8.44375 4.45898 13.0001C4.45898 17.5564 8.15264 21.2501 12.709 21.2501C17.2653 21.2501 20.959 17.5564 20.959 13.0001C20.959 8.44375 17.2653 4.7501 12.709 4.7501ZM2.95898 13.0001C2.95898 7.61532 7.32421 3.2501 12.709 3.2501C18.0938 3.2501 22.459 7.61532 22.459 13.0001C22.459 18.3849 18.0938 22.7501 12.709 22.7501C7.32421 22.7501 2.95898 18.3849 2.95898 13.0001ZM12.709 8.2501C13.1232 8.2501 13.459 8.58589 13.459 9.0001V12.6894L15.7393 14.9698C16.0322 15.2627 16.0322 15.7375 15.7393 16.0304C15.4464 16.3233 14.9715 16.3233 14.6787 16.0304L12.1787 13.5304C12.038 13.3898 11.959 13.199 11.959 13.0001V9.0001C11.959 8.58589 12.2948 8.2501 12.709 8.2501Z"
      fill="currentColor"
    />
  </svg>
)
